
// import React, { useState, useEffect, useCallback } from "react";
// import {
//   BarChart3, Phone, Users, Building2, Calendar,
//   CheckCircle2, TrendingUp, Download, RefreshCw,
//   ChevronDown, ChevronRight, IndianRupee, Filter,
// } from "lucide-react";
// import { fetchMISReport } from "../callLogApi";
// import api from "../api/api";
// import "./MISPage.css";

// /* ─── Constants ─── */
// const PERIODS = [
//   { label: "Daily",   value: "daily"   },
//   { label: "Weekly",  value: "weekly"  },
//   { label: "Monthly", value: "monthly" },
//   { label: "Custom",  value: "custom"  },
// ];

// const STATUS_OPTIONS = ["All","New","Interested","Negotiating","Closed","Not Interested","Follow-up"];

// const statMeta = [
//   { key: "numberOfCalls",      label: "Calls",      icon: Phone,        color: "#6366f1" },
//   { key: "numberOfLeads",      label: "Leads",      icon: Users,        color: "#10b981" },
//   { key: "numberOfProperties", label: "Properties", icon: Building2,    color: "#f59e0b" },
//   { key: "numberOfDeals",      label: "Deals",      icon: TrendingUp,   color: "#8b5cf6" },
//   { key: "meetingsScheduled",  label: "Meetings",   icon: Calendar,     color: "#3b82f6" },
//   { key: "visits",             label: "Visits",     icon: CheckCircle2, color: "#06b6d4" },
//   { key: "closedStatus",       label: "Closed",     icon: CheckCircle2, color: "#22c55e" },
// ];

// const STAGE_COLOR = {
//   negotiation:     { bg: "#fef9c3", color: "#a16207" },
//   documentation:   { bg: "#dbeafe", color: "#1d4ed8" },
//   payment_pending: { bg: "#fee2e2", color: "#dc2626" },
//   closed_won:      { bg: "#dcfce7", color: "#15803d" },
//   closed_lost:     { bg: "#f3f4f6", color: "#6b7280" },
// };

// const STATUS_PIE = {
//   New:"#6366f1", Interested:"#10b981", Negotiating:"#f59e0b",
//   Closed:"#22c55e", NotInterested:"#ef4444", Followup:"#8b5cf6",
// };
// const STATUS_PIE_LABELS = {
//   New:"New", Interested:"Interested", Negotiating:"Negotiating",
//   Closed:"Closed", NotInterested:"Not Interested", Followup:"Follow-up",
// };

// // Metrics shown in pie charts
// const PIE_METRICS = [
//   { key: "numberOfCalls",      label: "Calls",      color: "#6366f1" },
//   { key: "numberOfLeads",      label: "Leads",      color: "#10b981" },
//   { key: "numberOfProperties", label: "Props",      color: "#f59e0b" },
//   { key: "numberOfDeals",      label: "Deals",      color: "#8b5cf6" },
//   { key: "meetingsScheduled",  label: "Meetings",   color: "#3b82f6" },
//   { key: "closedStatus",       label: "Closed",     color: "#22c55e" },
// ];

// /* ─── Helpers ─── */
// const sumField = (data, key) => data.reduce((a, r) => a + (r[key] || 0), 0);
// const fmt      = (n) => n ? `₹${Number(n).toLocaleString("en-IN")}` : "—";

// function getAdminFlag() {
//   try {
//     const p = JSON.parse(atob(localStorage.getItem("token").split(".")[1]));
//     return p.role === "admin" || p.isAdmin === true;
//   } catch { return false; }
// }

// /* ─── SVG Status Donut (table column) ─── */
// function StatusPie({ breakdown }) {
//   if (!breakdown) return <span className="mis-pie-empty">—</span>;
//   const entries = Object.entries(breakdown).filter(([, v]) => v > 0);
//   const total   = entries.reduce((s, [, v]) => s + v, 0);
//   if (!total)    return <span className="mis-pie-empty">—</span>;

//   const R = 17; const CX = 22; const CY = 22;
//   const circ = 2 * Math.PI * R;
//   let cum = 0;
//   const slices = entries.map(([k, v]) => {
//     const pct  = v / total;
//     const dash = pct * circ;
//     const off  = circ - cum * circ;
//     cum += pct;
//     return { k, dash, off, color: STATUS_PIE[k] || "#ccc", v, lbl: STATUS_PIE_LABELS[k] || k };
//   });

//   return (
//     <div className="mis-pie-wrap" title={slices.map(s => `${s.lbl}: ${s.v}`).join(" | ")}>
//       <svg width={44} height={44} viewBox="0 0 44 44">
//         {slices.map(({ k, dash, off, color }) => (
//           <circle key={k} cx={CX} cy={CY} r={R} fill="none"
//             stroke={color} strokeWidth={9}
//             strokeDasharray={`${dash} ${circ - dash}`}
//             strokeDashoffset={off}
//             transform={`rotate(-90 ${CX} ${CY})`}
//           />
//         ))}
//         <circle cx={CX} cy={CY} r={10} fill="#fff"/>
//         <text x={CX} y={CY+4} textAnchor="middle" fontSize="9" fontWeight="700" fill="#374151">
//           {total}
//         </text>
//       </svg>
//     </div>
//   );
// }

// /* ─── Single Donut SVG (large, for chart section) ─── */
// function DonutChart({ slices, total, label, size = 160, strokeW = 28 }) {
//   const R    = (size - strokeW) / 2;
//   const CX   = size / 2;
//   const CY   = size / 2;
//   const circ = 2 * Math.PI * R;

//   if (!total) {
//     return (
//       <svg width={size} height={size}>
//         <circle cx={CX} cy={CY} r={R} fill="none" stroke="#f3f4f6" strokeWidth={strokeW}/>
//         <text x={CX} y={CY - 6} textAnchor="middle" fontSize="13" fill="#9ca3af">No</text>
//         <text x={CX} y={CY + 10} textAnchor="middle" fontSize="13" fill="#9ca3af">data</text>
//       </svg>
//     );
//   }

//   let cum = 0;
//   const drawn = slices.filter(s => s.value > 0).map(s => {
//     const pct  = s.value / total;
//     const dash = pct * circ;
//     const off  = circ - cum * circ;
//     cum += pct;
//     return { ...s, dash, off };
//   });

//   return (
//     <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
//       {drawn.map((s, i) => (
//         <circle key={i} cx={CX} cy={CY} r={R} fill="none"
//           stroke={s.color} strokeWidth={strokeW}
//           strokeDasharray={`${s.dash} ${circ - s.dash}`}
//           strokeDashoffset={s.off}
//           transform={`rotate(-90 ${CX} ${CY})`}
//         >
//           <title>{s.label}: {s.value}</title>
//         </circle>
//       ))}
//       {/* White center hole */}
//       <circle cx={CX} cy={CY} r={R - strokeW / 2 - 2} fill="#fff"/>
//       <text x={CX} y={CY - 8} textAnchor="middle" fontSize="22" fontWeight="800" fill="#111827">{total}</text>
//       <text x={CX} y={CY + 10} textAnchor="middle" fontSize="11" fill="#6b7280">{label}</text>
//     </svg>
//   );
// }

// /* ─── Pie Chart Section (replaces MultiBarChart) ─── */
// function PieChartSection({ rows }) {
//   const [activeMetrics, setActiveMetrics] = useState(PIE_METRICS.map(m => m.key));

//   const toggleMetric = (key) =>
//     setActiveMetrics(prev =>
//       prev.includes(key)
//         ? prev.filter(k => k !== key)
//         : [...prev, key]
//     );

//   const visibleMetrics = PIE_METRICS.filter(m => activeMetrics.includes(m.key));

//   // Combined totals donut (all agents)
//   const combinedSlices = visibleMetrics.map(m => ({
//     label: m.label,
//     color: m.color,
//     value: sumField(rows, m.key),
//   }));
//   const combinedTotal = combinedSlices.reduce((s, sl) => s + sl.value, 0);

//   return (
//     <div className="mis-chart-box">
//       <div className="mis-chart-header">
//         <h3>Agent Performance — Pie View</h3>
//         {/* Legend / metric toggles */}
//         <div className="mis-chart-legend">
//           {PIE_METRICS.map(m => (
//             <button key={m.key}
//               className={`mis-legend-btn ${activeMetrics.includes(m.key) ? "on" : "off"}`}
//               onClick={() => toggleMetric(m.key)}
//               style={activeMetrics.includes(m.key)
//                 ? { borderColor: m.color, color: m.color, background: m.color + "18" }
//                 : {}}
//             >
//               <span className="mis-legend-dot"
//                 style={{ background: activeMetrics.includes(m.key) ? m.color : "#d1d5db" }}/>
//               {m.label}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="mis-pie-charts-grid">

//         {/* Combined totals donut */}
//         <div className="mis-pie-agent-card mis-pie-combined">
//           <div className="mis-pie-donut">
//             <DonutChart slices={combinedSlices} total={combinedTotal} label="Total" size={160} strokeW={28}/>
//           </div>
//           <p className="mis-pie-agent-name">All Agents</p>
//           <div className="mis-pie-legend-list">
//             {visibleMetrics.map(m => (
//               <div key={m.key} className="mis-pie-legend-item">
//                 <span className="mis-pie-legend-dot" style={{ background: m.color }}/>
//                 <span className="mis-pie-legend-label">{m.label}</span>
//                 <span className="mis-pie-legend-val" style={{ color: m.color }}>
//                   {sumField(rows, m.key)}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Per-agent donuts */}
//         {rows.map((r, i) => {
//           const agentSlices = visibleMetrics.map(m => ({
//             label: m.label,
//             color: m.color,
//             value: r[m.key] || 0,
//           }));
//           const agentTotal = agentSlices.reduce((s, sl) => s + sl.value, 0);

//           return (
//             <div key={r._id || i} className="mis-pie-agent-card">
//               <div className="mis-pie-donut">
//                 <DonutChart
//                   slices={agentSlices}
//                   total={agentTotal}
//                   label="total"
//                   size={140}
//                   strokeW={24}
//                 />
//               </div>
//               <p className="mis-pie-agent-name">{r.userName}</p>
//               <div className="mis-pie-legend-list">
//                 {visibleMetrics.map(m => {
//                   const val = r[m.key] || 0;
//                   if (!val) return null;
//                   return (
//                     <div key={m.key} className="mis-pie-legend-item">
//                       <span className="mis-pie-legend-dot" style={{ background: m.color }}/>
//                       <span className="mis-pie-legend-label">{m.label}</span>
//                       <span className="mis-pie-legend-val" style={{ color: m.color }}>{val}</span>
//                     </div>
//                   );
//                 })}
//                 {agentTotal === 0 && (
//                   <p style={{ fontSize: "0.75rem", color: "#9ca3af", margin: 0 }}>No activity</p>
//                 )}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// /* ─── Main Page ─── */
// export default function MISPage() {
//   const [period,   setPeriod]   = useState("weekly");
//   const [from,     setFrom]     = useState("");
//   const [to,       setTo]       = useState("");
//   const [status,   setStatus]   = useState("All");
//   const [userId,   setUserId]   = useState("");
//   const [users,    setUsers]    = useState([]);
//   const [report,   setReport]   = useState(null);
//   const [loading,  setLoading]  = useState(false);
//   const [expanded, setExpanded] = useState({});
//   const adminFlag = getAdminFlag();

//   useEffect(() => {
//     if (adminFlag) api.get("/users").then(r => setUsers(r.data)).catch(() => {});
//   }, [adminFlag]);

//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const params = { period };
//       if (period === "custom") { params.from = from; params.to = to; }
//       if (status !== "All")    params.status = status;
//       if (userId)              params.userId = userId;
//       const { data } = await fetchMISReport(params);
//       setReport(data);
//       setExpanded({});
//     } catch (err) { console.error(err); }
//     finally { setLoading(false); }
//   }, [period, from, to, status, userId]);

//   useEffect(() => { if (period !== "custom") load(); }, [period, load]);

//   const exportExcel = () => {
//     const token  = localStorage.getItem("token");
//     const params = new URLSearchParams({ period });
//     if (period === "custom" && from) params.append("from",   from);
//     if (period === "custom" && to)   params.append("to",     to);
//     if (status !== "All")            params.append("status", status);
//     if (userId)                      params.append("userId", userId);

//     fetch(`/api/call-logs/mis/export?${params}`, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//       .then(res => { if (!res.ok) throw new Error("Export failed"); return res.blob(); })
//       .then(blob => {
//         const url = URL.createObjectURL(blob);
//         const a   = Object.assign(document.createElement("a"), {
//           href: url,
//           download: `MIS_${period}_${new Date().toISOString().slice(0,10)}.xlsx`,
//         });
//         a.click();
//         URL.revokeObjectURL(url);
//       })
//       .catch(e => alert("Export error: " + e.message));
//   };

//   const toggleRow = (idx) => setExpanded(p => ({ ...p, [idx]: !p[idx] }));

//   const rows   = report?.data || [];
//   const totals = statMeta.map(m => ({ ...m, value: sumField(rows, m.key) }));

//   return (
//     <div className="mis-page">

//       {/* Header */}
//       <div className="mis-topbar">
//         <div className="mis-heading">
//           <div className="mis-icon-wrap"><BarChart3 size={22}/></div>
//           <div>
//             <h1>MIS Report</h1>
//             <p>Call analytics · Leads · Properties · Deals · Status breakdown</p>
//           </div>
//         </div>
//         <button className="mis-btn-export" onClick={exportExcel}>
//           <Download size={15}/> Export Excel
//         </button>
//       </div>

//       {/* Filters */}
//       <div className="mis-filters-bar">
//         <div className="mis-tabs">
//           {PERIODS.map(p => (
//             <button key={p.value}
//               className={`mis-tab ${period === p.value ? "active" : ""}`}
//               onClick={() => setPeriod(p.value)}>
//               {p.label}
//             </button>
//           ))}
//         </div>

//         {period === "custom" && (
//           <div className="mis-custom-range">
//             <input type="date" value={from} onChange={e => setFrom(e.target.value)}/>
//             <span>→</span>
//             <input type="date" value={to}   onChange={e => setTo(e.target.value)}/>
//           </div>
//         )}

//         <div className="mis-filter-group">
//           <Filter size={13}/>
//           <select value={status} onChange={e => setStatus(e.target.value)}>
//             {STATUS_OPTIONS.map(s => <option key={s}>{s}</option>)}
//           </select>
//         </div>

//         {adminFlag && (
//           <div className="mis-filter-group">
//             <Users size={13}/>
//             <select value={userId} onChange={e => setUserId(e.target.value)}>
//               <option value="">All Agents</option>
//               {users.map(u => (
//                 <option key={u._id} value={u._id}>{u.name || u.Name}</option>
//               ))}
//             </select>
//           </div>
//         )}

//         <button className="mis-btn-apply" onClick={load}>
//           <RefreshCw size={13}/> Apply
//         </button>
//       </div>

//       {report && (
//         <p className="mis-range-label">
//           {new Date(report.from).toLocaleDateString("en-IN")} →{" "}
//           {new Date(report.to).toLocaleDateString("en-IN")}
//           {" · "}{rows.length} agent{rows.length !== 1 ? "s" : ""}
//           {status !== "All" && <> · Status: <strong>{status}</strong></>}
//         </p>
//       )}

//       {loading ? (
//         <div className="mis-loading"><div className="mis-spinner"/><p>Generating report…</p></div>
//       ) : (
//         <>
//           {/* Summary Cards */}
//           <div className="mis-cards">
//             {totals.map(({ key, label, icon: Icon, color, value }) => (
//               <div key={key} className="mis-card">
//                 <div className="mis-card-icon" style={{ background: color + "20", color }}>
//                   <Icon size={20}/>
//                 </div>
//                 <div>
//                   <p className="mis-card-val">{value}</p>
//                   <p className="mis-card-label">{label}</p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Pie Chart (replaces bar chart) */}
//           {rows.length > 0 && <PieChartSection rows={rows}/>}

//           {/* Table */}
//           <div className="mis-table-wrap">
//             {rows.length === 0 ? (
//               <div className="mis-empty">
//                 <BarChart3 size={44} strokeWidth={1}/><p>No data for this period</p>
//               </div>
//             ) : (
//               <table className="mis-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: 32 }}/>
//                     <th>#</th>
//                     <th>Agent</th>
//                     <th>Calls</th>
//                     <th>Leads</th>
//                     <th>Props</th>
//                     <th>Deals</th>
//                     <th>Meetings</th>
//                     <th>Visits</th>
//                     <th>Closed</th>
//                     <th>Status Mix</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rows.map((r, idx) => (
//                     <React.Fragment key={r._id || idx}>
//                       <tr className="mis-main-row" onClick={() => toggleRow(idx)}>
//                         <td className="mis-expand-cell">
//                           {expanded[idx] ? <ChevronDown size={14}/> : <ChevronRight size={14}/>}
//                         </td>
//                         <td className="mis-rank">{idx + 1}</td>
//                         <td>
//                           <div className="mis-user">
//                             <div className="mis-avatar">{r.userName?.[0]?.toUpperCase()}</div>
//                             <div>
//                               <p className="mis-uname">{r.userName}</p>
//                               <p className="mis-uemail">{r.userEmail}</p>
//                             </div>
//                           </div>
//                         </td>
//                         <td><span className="mis-num calls">{r.numberOfCalls}</span></td>
//                         <td><span className="mis-num leads">{r.numberOfLeads}</span></td>
//                         <td><span className="mis-num props">{r.numberOfProperties}</span></td>
//                         <td><span className="mis-num deals">{r.numberOfDeals}</span></td>
//                         <td><span className="mis-num meets">{r.meetingsScheduled}</span></td>
//                         <td><span className="mis-num visits">{r.visits}</span></td>
//                         <td>
//                           <span className={`mis-closed ${r.closedStatus > 0 ? "has" : "zero"}`}>
//                             {r.closedStatus}
//                           </span>
//                         </td>
//                         <td><StatusPie breakdown={r.statusBreakdown}/></td>
//                       </tr>

//                       {expanded[idx] && (
//                         <tr className="mis-detail-row">
//                           <td colSpan={11}>
//                             <div className="mis-detail-grid">

//                               {r.statusBreakdown && (
//                                 <div className="mis-detail-section mis-sb-section">
//                                   <h4><BarChart3 size={13}/> Status Breakdown</h4>
//                                   <div className="mis-status-chips">
//                                     {Object.entries(r.statusBreakdown).map(([k, v]) =>
//                                       v > 0 ? (
//                                         <span key={k} className="mis-status-chip"
//                                           style={{
//                                             background: (STATUS_PIE[k] || "#6b7280") + "18",
//                                             color:       STATUS_PIE[k] || "#6b7280",
//                                             border:     `1px solid ${(STATUS_PIE[k] || "#6b7280")}40`,
//                                           }}>
//                                           {STATUS_PIE_LABELS[k] || k}: <strong>{v}</strong>
//                                         </span>
//                                       ) : null
//                                     )}
//                                   </div>
//                                 </div>
//                               )}

//                               {r.leads?.length > 0 && (
//                                 <div className="mis-detail-section">
//                                   <h4><Users size={13}/> Leads ({r.leads.length})</h4>
//                                   {r.leads.filter(Boolean).map(l => (
//                                     <div key={l._id} className="mis-detail-card lead-card">
//                                       <p className="dc-name">{l.name || "—"}</p>
//                                       <p className="dc-sub">
//                                         {l.phone}{l.status && ` · ${l.status}`}{l.interest_level && ` · ⭐ ${l.interest_level}`}
//                                       </p>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}

//                               {r.properties?.length > 0 && (
//                                 <div className="mis-detail-section">
//                                   <h4><Building2 size={13}/> Properties ({r.properties.length})</h4>
//                                   {r.properties.filter(Boolean).map(p => (
//                                     <div key={p._id} className="mis-detail-card prop-card">
//                                       <p className="dc-name">{p.name || "—"}</p>
//                                       <p className="dc-sub">
//                                         {p.location}{p.price && ` · ${fmt(p.price)}`}{p.status && ` · ${p.status}`}
//                                       </p>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}

//                               {r.deals?.length > 0 && (
//                                 <div className="mis-detail-section">
//                                   <h4><TrendingUp size={13}/> Deals ({r.deals.length})</h4>
//                                   {r.deals.filter(Boolean).map(d => {
//                                     const sc = STAGE_COLOR[d.stage] || { bg: "#f3f4f6", color: "#374151" };
//                                     return (
//                                       <div key={d._id} className="mis-detail-card deal-card">
//                                         <div className="dc-deal-top">
//                                           <p className="dc-name">{d.name || "—"}</p>
//                                           <span className="dc-stage" style={{ background: sc.bg, color: sc.color }}>{d.stage}</span>
//                                         </div>
//                                         <p className="dc-sub">
//                                           {d.dealValue && <><IndianRupee size={11}/>{Number(d.dealValue).toLocaleString("en-IN")}</>}
//                                           {d.expectedCloseDate && ` · Close: ${new Date(d.expectedCloseDate).toLocaleDateString()}`}
//                                           {d.agreementSigned && " · ✓ Signed"}
//                                         </p>
//                                       </div>
//                                     );
//                                   })}
//                                 </div>
//                               )}

//                               {(!r.leads?.length && !r.properties?.length && !r.deals?.length && !r.statusBreakdown) && (
//                                 <p className="mis-detail-empty">No linked entities for this agent in this period.</p>
//                               )}
//                             </div>
//                           </td>
//                         </tr>
//                       )}
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//                 <tfoot>
//                   <tr className="mis-total-row">
//                     <td colSpan={3}><strong>Total</strong></td>
//                     {statMeta.map(m => (
//                       <td key={m.key}><strong>{sumField(rows, m.key)}</strong></td>
//                     ))}
//                     <td/>
//                   </tr>
//                 </tfoot>
//               </table>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   BarChart3, Phone, Users, Building2, Calendar,
//   CheckCircle2, TrendingUp, Download, RefreshCw,
//   ChevronDown, ChevronRight, IndianRupee, Filter,
// } from "lucide-react";
// import { fetchMISReport } from "../callLogApi";
// import api from "../api/api";
// import "./MISPage.css";

// /* ─── Constants ─── */
// const PERIODS = [
//   { label: "Daily",   value: "daily"   },
//   { label: "Weekly",  value: "weekly"  },
//   { label: "Monthly", value: "monthly" },
//   { label: "Custom",  value: "custom"  },
// ];

// const STATUS_OPTIONS = ["All","New","Interested","Negotiating","Closed","Not Interested","Follow-up"];

// const statMeta = [
//   { key: "numberOfCalls",      label: "Calls",      icon: Phone,        color: "#6366f1" },
//   { key: "numberOfLeads",      label: "Leads",      icon: Users,        color: "#10b981" },
//   { key: "numberOfProperties", label: "Properties", icon: Building2,    color: "#f59e0b" },
//   { key: "numberOfDeals",      label: "Deals",      icon: TrendingUp,   color: "#8b5cf6" },
//   { key: "meetingsScheduled",  label: "Meetings",   icon: Calendar,     color: "#3b82f6" },
//   { key: "visits",             label: "Visits",     icon: CheckCircle2, color: "#06b6d4" },
//   { key: "closedStatus",       label: "Closed",     icon: CheckCircle2, color: "#22c55e" },
// ];

// const STAGE_COLOR = {
//   negotiation:     { bg: "#fef9c3", color: "#a16207" },
//   documentation:   { bg: "#dbeafe", color: "#1d4ed8" },
//   payment_pending: { bg: "#fee2e2", color: "#dc2626" },
//   closed_won:      { bg: "#dcfce7", color: "#15803d" },
//   closed_lost:     { bg: "#f3f4f6", color: "#6b7280" },
// };

// const STATUS_PIE = {
//   New:"#6366f1", Interested:"#10b981", Negotiating:"#f59e0b",
//   Closed:"#22c55e", NotInterested:"#ef4444", Followup:"#8b5cf6",
// };
// const STATUS_PIE_LABELS = {
//   New:"New", Interested:"Interested", Negotiating:"Negotiating",
//   Closed:"Closed", NotInterested:"Not Interested", Followup:"Follow-up",
// };

// // Metrics shown in pie charts
// const PIE_METRICS = [
//   { key: "numberOfCalls",      label: "Calls",      color: "#6366f1" },
//   { key: "numberOfLeads",      label: "Leads",      color: "#10b981" },
//   { key: "numberOfProperties", label: "Props",      color: "#f59e0b" },
//   { key: "numberOfDeals",      label: "Deals",      color: "#8b5cf6" },
//   { key: "meetingsScheduled",  label: "Meetings",   color: "#3b82f6" },
//   { key: "closedStatus",       label: "Closed",     color: "#22c55e" },
// ];

// /* ─── Helpers ─── */
// const sumField = (data, key) => data.reduce((a, r) => a + (r[key] || 0), 0);
// const fmt      = (n) => n ? `₹${Number(n).toLocaleString("en-IN")}` : "—";

// function getAdminFlag() {
//   try {
//     const p = JSON.parse(atob(localStorage.getItem("token").split(".")[1]));
//     return p.role === "admin" || p.isAdmin === true;
//   } catch { return false; }
// }

// /* ─── SVG Status Donut (table column) ─── */
// function StatusPie({ breakdown }) {
//   if (!breakdown) return <span className="mis-pie-empty">—</span>;
//   const entries = Object.entries(breakdown).filter(([, v]) => v > 0);
//   const total   = entries.reduce((s, [, v]) => s + v, 0);
//   if (!total)    return <span className="mis-pie-empty">—</span>;

//   const R = 17; const CX = 22; const CY = 22;
//   const circ = 2 * Math.PI * R;
//   let cum = 0;
//   const slices = entries.map(([k, v]) => {
//     const pct  = v / total;
//     const dash = pct * circ;
//     const off  = circ - cum * circ;
//     cum += pct;
//     return { k, dash, off, color: STATUS_PIE[k] || "#ccc", v, lbl: STATUS_PIE_LABELS[k] || k };
//   });

//   return (
//     <div className="mis-pie-wrap" title={slices.map(s => `${s.lbl}: ${s.v}`).join(" | ")}>
//       <svg width={44} height={44} viewBox="0 0 44 44">
//         {slices.map(({ k, dash, off, color }) => (
//           <circle key={k} cx={CX} cy={CY} r={R} fill="none"
//             stroke={color} strokeWidth={9}
//             strokeDasharray={`${dash} ${circ - dash}`}
//             strokeDashoffset={off}
//             transform={`rotate(-90 ${CX} ${CY})`}
//           />
//         ))}
//         <circle cx={CX} cy={CY} r={10} fill="#fff"/>
//         <text x={CX} y={CY+4} textAnchor="middle" fontSize="9" fontWeight="700" fill="#374151">
//           {total}
//         </text>
//       </svg>
//     </div>
//   );
// }

// /* ─── Single Donut SVG (large, for chart section) ─── */
// function DonutChart({ slices, total, label, size = 160, strokeW = 28 }) {
//   const R    = (size - strokeW) / 2;
//   const CX   = size / 2;
//   const CY   = size / 2;
//   const circ = 2 * Math.PI * R;

//   if (!total) {
//     return (
//       <svg width={size} height={size}>
//         <circle cx={CX} cy={CY} r={R} fill="none" stroke="#f3f4f6" strokeWidth={strokeW}/>
//         <text x={CX} y={CY - 6} textAnchor="middle" fontSize="13" fill="#9ca3af">No</text>
//         <text x={CX} y={CY + 10} textAnchor="middle" fontSize="13" fill="#9ca3af">data</text>
//       </svg>
//     );
//   }

//   let cum = 0;
//   const drawn = slices.filter(s => s.value > 0).map(s => {
//     const pct  = s.value / total;
//     const dash = pct * circ;
//     const off  = circ - cum * circ;
//     cum += pct;
//     return { ...s, dash, off };
//   });

//   return (
//     <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
//       {drawn.map((s, i) => (
//         <circle key={i} cx={CX} cy={CY} r={R} fill="none"
//           stroke={s.color} strokeWidth={strokeW}
//           strokeDasharray={`${s.dash} ${circ - s.dash}`}
//           strokeDashoffset={s.off}
//           transform={`rotate(-90 ${CX} ${CY})`}
//         >
//           <title>{s.label}: {s.value}</title>
//         </circle>
//       ))}
//       {/* White center hole */}
//       <circle cx={CX} cy={CY} r={R - strokeW / 2 - 2} fill="#fff"/>
//       <text x={CX} y={CY - 8} textAnchor="middle" fontSize="22" fontWeight="800" fill="#111827">{total}</text>
//       <text x={CX} y={CY + 10} textAnchor="middle" fontSize="11" fill="#6b7280">{label}</text>
//     </svg>
//   );
// }

// /* ─── Pie Chart Section (replaces MultiBarChart) ─── */
// function PieChartSection({ rows }) {
//   const [activeMetrics, setActiveMetrics] = useState(PIE_METRICS.map(m => m.key));

//   const toggleMetric = (key) =>
//     setActiveMetrics(prev =>
//       prev.includes(key)
//         ? prev.filter(k => k !== key)
//         : [...prev, key]
//     );

//   const visibleMetrics = PIE_METRICS.filter(m => activeMetrics.includes(m.key));

//   // Combined totals donut (all agents)
//   const combinedSlices = visibleMetrics.map(m => ({
//     label: m.label,
//     color: m.color,
//     value: sumField(rows, m.key),
//   }));
//   const combinedTotal = combinedSlices.reduce((s, sl) => s + sl.value, 0);

//   return (
//     <div className="mis-chart-box">
//       <div className="mis-chart-header">
//         <h3>Agent Performance — Pie View</h3>
//         {/* Legend / metric toggles */}
//         <div className="mis-chart-legend">
//           {PIE_METRICS.map(m => (
//             <button key={m.key}
//               className={`mis-legend-btn ${activeMetrics.includes(m.key) ? "on" : "off"}`}
//               onClick={() => toggleMetric(m.key)}
//               style={activeMetrics.includes(m.key)
//                 ? { borderColor: m.color, color: m.color, background: m.color + "18" }
//                 : {}}
//             >
//               <span className="mis-legend-dot"
//                 style={{ background: activeMetrics.includes(m.key) ? m.color : "#d1d5db" }}/>
//               {m.label}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="mis-pie-charts-grid">

//         {/* Combined totals donut */}
//         <div className="mis-pie-agent-card mis-pie-combined">
//           <div className="mis-pie-donut">
//             <DonutChart slices={combinedSlices} total={combinedTotal} label="Total" size={160} strokeW={28}/>
//           </div>
//           <p className="mis-pie-agent-name">All Agents</p>
//           <div className="mis-pie-legend-list">
//             {visibleMetrics.map(m => (
//               <div key={m.key} className="mis-pie-legend-item">
//                 <span className="mis-pie-legend-dot" style={{ background: m.color }}/>
//                 <span className="mis-pie-legend-label">{m.label}</span>
//                 <span className="mis-pie-legend-val" style={{ color: m.color }}>
//                   {sumField(rows, m.key)}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Per-agent donuts */}
//         {rows.map((r, i) => {
//           const agentSlices = visibleMetrics.map(m => ({
//             label: m.label,
//             color: m.color,
//             value: r[m.key] || 0,
//           }));
//           const agentTotal = agentSlices.reduce((s, sl) => s + sl.value, 0);

//           return (
//             <div key={r._id || i} className="mis-pie-agent-card">
//               <div className="mis-pie-donut">
//                 <DonutChart
//                   slices={agentSlices}
//                   total={agentTotal}
//                   label="total"
//                   size={140}
//                   strokeW={24}
//                 />
//               </div>
//               <p className="mis-pie-agent-name">{r.userName}</p>
//               <div className="mis-pie-legend-list">
//                 {visibleMetrics.map(m => {
//                   const val = r[m.key] || 0;
//                   if (!val) return null;
//                   return (
//                     <div key={m.key} className="mis-pie-legend-item">
//                       <span className="mis-pie-legend-dot" style={{ background: m.color }}/>
//                       <span className="mis-pie-legend-label">{m.label}</span>
//                       <span className="mis-pie-legend-val" style={{ color: m.color }}>{val}</span>
//                     </div>
//                   );
//                 })}
//                 {agentTotal === 0 && (
//                   <p style={{ fontSize: "0.75rem", color: "#9ca3af", margin: 0 }}>No activity</p>
//                 )}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// /* ─── Main Page ─── */
// export default function MISPage() {
//   const [period,   setPeriod]   = useState("weekly");
//   const [from,     setFrom]     = useState("");
//   const [to,       setTo]       = useState("");
//   const [status,   setStatus]   = useState("All");
//   const [userId,   setUserId]   = useState("");
//   const [users,    setUsers]    = useState([]);
//   const [report,   setReport]   = useState(null);
//   const [loading,  setLoading]  = useState(false);
//   const [expanded, setExpanded] = useState({});
//   const adminFlag = getAdminFlag();

//   useEffect(() => {
//     if (adminFlag) api.get("/users").then(r => setUsers(r.data)).catch(() => {});
//   }, [adminFlag]);

//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const params = { period };
//       if (period === "custom") { params.from = from; params.to = to; }
//       if (status !== "All")    params.status = status;
//       if (userId)              params.userId = userId;
//       const { data } = await fetchMISReport(params);
//       setReport(data);
//       setExpanded({});
//     } catch (err) { console.error(err); }
//     finally { setLoading(false); }
//   }, [period, from, to, status, userId]);

//   useEffect(() => { if (period !== "custom") load(); }, [period, load]);

//   const exportExcel = () => {
//     const token  = localStorage.getItem("token");
//     const params = new URLSearchParams({ period });
//     if (period === "custom" && from) params.append("from",   from);
//     if (period === "custom" && to)   params.append("to",     to);
//     if (status !== "All")            params.append("status", status);
//     if (userId)                      params.append("userId", userId);

//     fetch(`/api/call-logs/mis/export?${params}`, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//       .then(res => { if (!res.ok) throw new Error("Export failed"); return res.blob(); })
//       .then(blob => {
//         const url = URL.createObjectURL(blob);
//         const a   = Object.assign(document.createElement("a"), {
//           href: url,
//           download: `MIS_${period}_${new Date().toISOString().slice(0,10)}.xlsx`,
//         });
//         a.click();
//         URL.revokeObjectURL(url);
//       })
//       .catch(e => alert("Export error: " + e.message));
//   };

//   const toggleRow = (idx) => setExpanded(p => ({ ...p, [idx]: !p[idx] }));

//   const rows   = report?.data || [];
//   const totals = statMeta.map(m => ({ ...m, value: sumField(rows, m.key) }));

//   return (
//     <div className="mis-page">

//       {/* Header */}
//       <div className="mis-topbar">
//         <div className="mis-heading">
//           <div className="mis-icon-wrap"><BarChart3 size={22}/></div>
//           <div>
//             <h1>MIS Report</h1>
//             <p>Call analytics · Leads · Properties · Deals · Status breakdown</p>
//           </div>
//         </div>
//         <button className="mis-btn-export" onClick={exportExcel}>
//           <Download size={15}/> Export Excel
//         </button>
//       </div>

//       {/* Filters */}
//       <div className="mis-filters-bar">
//         <div className="mis-tabs">
//           {PERIODS.map(p => (
//             <button key={p.value}
//               className={`mis-tab ${period === p.value ? "active" : ""}`}
//               onClick={() => setPeriod(p.value)}>
//               {p.label}
//             </button>
//           ))}
//         </div>

//         {period === "custom" && (
//           <div className="mis-custom-range">
//             <input type="date" value={from} onChange={e => setFrom(e.target.value)}/>
//             <span>→</span>
//             <input type="date" value={to}   onChange={e => setTo(e.target.value)}/>
//           </div>
//         )}

//         <div className="mis-filter-group">
//           <Filter size={13}/>
//           <select value={status} onChange={e => setStatus(e.target.value)}>
//             {STATUS_OPTIONS.map(s => <option key={s}>{s}</option>)}
//           </select>
//         </div>

//         {adminFlag && (
//           <div className="mis-filter-group">
//             <Users size={13}/>
//             <select value={userId} onChange={e => setUserId(e.target.value)}>
//               <option value="">All Agents</option>
//               {users.map(u => (
//                 <option key={u._id} value={u._id}>{u.name || u.Name || u.fullName || u.username || u.email || u._id}</option>
//               ))}
//             </select>
//           </div>
//         )}

//         <button className="mis-btn-apply" onClick={load}>
//           <RefreshCw size={13}/> Apply
//         </button>
//       </div>

//       {report && (
//         <p className="mis-range-label">
//           {new Date(report.from).toLocaleDateString("en-IN")} →{" "}
//           {new Date(report.to).toLocaleDateString("en-IN")}
//           {" · "}{rows.length} agent{rows.length !== 1 ? "s" : ""}
//           {status !== "All" && <> · Status: <strong>{status}</strong></>}
//         </p>
//       )}

//       {loading ? (
//         <div className="mis-loading"><div className="mis-spinner"/><p>Generating report…</p></div>
//       ) : (
//         <>
//           {/* Summary Cards */}
//           <div className="mis-cards">
//             {totals.map(({ key, label, icon: Icon, color, value }) => (
//               <div key={key} className="mis-card">
//                 <div className="mis-card-icon" style={{ background: color + "20", color }}>
//                   <Icon size={20}/>
//                 </div>
//                 <div>
//                   <p className="mis-card-val">{value}</p>
//                   <p className="mis-card-label">{label}</p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Pie Chart (replaces bar chart) */}
//           {rows.length > 0 && <PieChartSection rows={rows}/>}

//           {/* Table */}
//           <div className="mis-table-wrap">
//             {rows.length === 0 ? (
//               <div className="mis-empty">
//                 <BarChart3 size={44} strokeWidth={1}/><p>No data for this period</p>
//               </div>
//             ) : (
//               <table className="mis-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: 32 }}/>
//                     <th>#</th>
//                     <th>Agent</th>
//                     <th>Calls</th>
//                     <th>Leads</th>
//                     <th>Props</th>
//                     <th>Deals</th>
//                     <th>Meetings</th>
//                     <th>Visits</th>
//                     <th>Closed</th>
//                     <th>Status Mix</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rows.map((r, idx) => (
//                     <React.Fragment key={r._id || idx}>
//                       <tr className="mis-main-row" onClick={() => toggleRow(idx)}>
//                         <td className="mis-expand-cell">
//                           {expanded[idx] ? <ChevronDown size={14}/> : <ChevronRight size={14}/>}
//                         </td>
//                         <td className="mis-rank">{idx + 1}</td>
//                         <td>
//                           <div className="mis-user">
//                             <div className="mis-avatar">{r.userName?.[0]?.toUpperCase()}</div>
//                             <div>
//                               <p className="mis-uname">{r.userName}</p>
//                               <p className="mis-uemail">{r.userEmail}</p>
//                             </div>
//                           </div>
//                         </td>
//                         <td><span className="mis-num calls">{r.numberOfCalls}</span></td>
//                         <td><span className="mis-num leads">{r.numberOfLeads}</span></td>
//                         <td><span className="mis-num props">{r.numberOfProperties}</span></td>
//                         <td><span className="mis-num deals">{r.numberOfDeals}</span></td>
//                         <td><span className="mis-num meets">{r.meetingsScheduled}</span></td>
//                         <td><span className="mis-num visits">{r.visits}</span></td>
//                         <td>
//                           <span className={`mis-closed ${r.closedStatus > 0 ? "has" : "zero"}`}>
//                             {r.closedStatus}
//                           </span>
//                         </td>
//                         <td><StatusPie breakdown={r.statusBreakdown}/></td>
//                       </tr>

//                       {expanded[idx] && (
//                         <tr className="mis-detail-row">
//                           <td colSpan={11}>
//                             <div className="mis-detail-grid">

//                               {r.statusBreakdown && (
//                                 <div className="mis-detail-section mis-sb-section">
//                                   <h4><BarChart3 size={13}/> Status Breakdown</h4>
//                                   <div className="mis-status-chips">
//                                     {Object.entries(r.statusBreakdown).map(([k, v]) =>
//                                       v > 0 ? (
//                                         <span key={k} className="mis-status-chip"
//                                           style={{
//                                             background: (STATUS_PIE[k] || "#6b7280") + "18",
//                                             color:       STATUS_PIE[k] || "#6b7280",
//                                             border:     `1px solid ${(STATUS_PIE[k] || "#6b7280")}40`,
//                                           }}>
//                                           {STATUS_PIE_LABELS[k] || k}: <strong>{v}</strong>
//                                         </span>
//                                       ) : null
//                                     )}
//                                   </div>
//                                 </div>
//                               )}

//                               {r.leads?.length > 0 && (
//                                 <div className="mis-detail-section">
//                                   <h4><Users size={13}/> Leads ({r.leads.length})</h4>
//                                   {r.leads.filter(Boolean).map(l => (
//                                     <div key={l._id} className="mis-detail-card lead-card">
//                                       <p className="dc-name">{l.name || "—"}</p>
//                                       <p className="dc-sub">
//                                         {l.phone}{l.status && ` · ${l.status}`}{l.interest_level && ` · ⭐ ${l.interest_level}`}
//                                       </p>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}

//                               {r.properties?.length > 0 && (
//                                 <div className="mis-detail-section">
//                                   <h4><Building2 size={13}/> Properties ({r.properties.length})</h4>
//                                   {r.properties.filter(Boolean).map(p => (
//                                     <div key={p._id} className="mis-detail-card prop-card">
//                                       <p className="dc-name">{p.name || "—"}</p>
//                                       <p className="dc-sub">
//                                         {p.location}{p.price && ` · ${fmt(p.price)}`}{p.status && ` · ${p.status}`}
//                                       </p>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}

//                               {r.deals?.length > 0 && (
//                                 <div className="mis-detail-section">
//                                   <h4><TrendingUp size={13}/> Deals ({r.deals.length})</h4>
//                                   {r.deals.filter(Boolean).map(d => {
//                                     const sc = STAGE_COLOR[d.stage] || { bg: "#f3f4f6", color: "#374151" };
//                                     return (
//                                       <div key={d._id} className="mis-detail-card deal-card">
//                                         <div className="dc-deal-top">
//                                           <p className="dc-name">{d.name || "—"}</p>
//                                           <span className="dc-stage" style={{ background: sc.bg, color: sc.color }}>{d.stage}</span>
//                                         </div>
//                                         <p className="dc-sub">
//                                           {d.dealValue && <><IndianRupee size={11}/>{Number(d.dealValue).toLocaleString("en-IN")}</>}
//                                           {d.expectedCloseDate && ` · Close: ${new Date(d.expectedCloseDate).toLocaleDateString()}`}
//                                           {d.agreementSigned && " · ✓ Signed"}
//                                         </p>
//                                       </div>
//                                     );
//                                   })}
//                                 </div>
//                               )}

//                               {(!r.leads?.length && !r.properties?.length && !r.deals?.length && !r.statusBreakdown) && (
//                                 <p className="mis-detail-empty">No linked entities for this agent in this period.</p>
//                               )}
//                             </div>
//                           </td>
//                         </tr>
//                       )}
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//                 <tfoot>
//                   <tr className="mis-total-row">
//                     <td colSpan={3}><strong>Total</strong></td>
//                     {statMeta.map(m => (
//                       <td key={m.key}><strong>{sumField(rows, m.key)}</strong></td>
//                     ))}
//                     <td/>
//                   </tr>
//                 </tfoot>
//               </table>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// // Pages/MISPage.jsx
// // Updated: 07-05-2026
// // ─ Status filter + User filter (admin)
// // ─ Excel export via backend (/api/call-logs/mis/export)
// // ─ Multi-metric bar chart with toggleable metrics
// // ─ SVG status donut per agent row
// // ─ Status breakdown chips in expanded row

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   BarChart3, Phone, Users, Building2, Calendar,
//   CheckCircle2, TrendingUp, Download, RefreshCw,
//   ChevronDown, ChevronRight, IndianRupee, Filter,
// } from "lucide-react";
// import { fetchMISReport } from "../callLogApi";
// import api from "../api/api";
// import "./MISPage.css";

// /* ─── Constants ─── */
// const PERIODS = [
//   { label: "Daily",   value: "daily"   },
//   { label: "Weekly",  value: "weekly"  },
//   { label: "Monthly", value: "monthly" },
//   { label: "Custom",  value: "custom"  },
// ];

// const STATUS_OPTIONS = ["All","New","Interested","Negotiating","Closed","Not Interested","Follow-up"];

// const statMeta = [
//   { key: "numberOfCalls",      label: "Calls",      icon: Phone,        color: "#6366f1" },
//   { key: "numberOfLeads",      label: "Leads",      icon: Users,        color: "#10b981" },
//   { key: "numberOfProperties", label: "Properties", icon: Building2,    color: "#f59e0b" },
//   { key: "numberOfDeals",      label: "Deals",      icon: TrendingUp,   color: "#8b5cf6" },
//   { key: "meetingsScheduled",  label: "Meetings",   icon: Calendar,     color: "#3b82f6" },
//   { key: "visits",             label: "Visits",     icon: CheckCircle2, color: "#06b6d4" },
//   { key: "closedStatus",       label: "Closed",     icon: CheckCircle2, color: "#22c55e" },
// ];

// const STAGE_COLOR = {
//   negotiation:     { bg: "#fef9c3", color: "#a16207" },
//   documentation:   { bg: "#dbeafe", color: "#1d4ed8" },
//   payment_pending: { bg: "#fee2e2", color: "#dc2626" },
//   closed_won:      { bg: "#dcfce7", color: "#15803d" },
//   closed_lost:     { bg: "#f3f4f6", color: "#6b7280" },
// };

// const STATUS_PIE = {
//   New:"#6366f1", Interested:"#10b981", Negotiating:"#f59e0b",
//   Closed:"#22c55e", NotInterested:"#ef4444", Followup:"#8b5cf6",
// };
// const STATUS_PIE_LABELS = {
//   New:"New", Interested:"Interested", Negotiating:"Negotiating",
//   Closed:"Closed", NotInterested:"Not Interested", Followup:"Follow-up",
// };

// const CHART_METRICS = [
//   { key: "numberOfCalls",      label: "Calls",   color: "#6366f1" },
//   { key: "numberOfLeads",      label: "Leads",   color: "#10b981" },
//   { key: "numberOfProperties", label: "Props",   color: "#f59e0b" },
//   { key: "numberOfDeals",      label: "Deals",   color: "#8b5cf6" },
//   { key: "meetingsScheduled",  label: "Meets",   color: "#3b82f6" },
//   { key: "closedStatus",       label: "Closed",  color: "#22c55e" },
// ];

// /* ─── Helpers ─── */
// const sumField = (data, key) => data.reduce((a, r) => a + (r[key] || 0), 0);
// const fmt      = (n) => n ? `₹${Number(n).toLocaleString("en-IN")}` : "—";

// function getAdminFlag() {
//   try {
//     const p = JSON.parse(atob(localStorage.getItem("token").split(".")[1]));
//     return p.role === "admin" || p.isAdmin === true;
//   } catch { return false; }
// }

// /* ─── SVG Status Donut ─── */
// function StatusPie({ breakdown }) {
//   if (!breakdown) return <span className="mis-pie-empty">—</span>;
//   const entries = Object.entries(breakdown).filter(([, v]) => v > 0);
//   const total   = entries.reduce((s, [, v]) => s + v, 0);
//   if (!total)    return <span className="mis-pie-empty">—</span>;

//   const R = 17; const CX = 22; const CY = 22;
//   const circ = 2 * Math.PI * R;
//   let cum = 0;
//   const slices = entries.map(([k, v]) => {
//     const pct  = v / total;
//     const dash = pct * circ;
//     const off  = circ - cum * circ;
//     cum += pct;
//     return { k, dash, off, color: STATUS_PIE[k] || "#ccc", v, lbl: STATUS_PIE_LABELS[k] || k };
//   });

//   return (
//     <div className="mis-pie-wrap" title={slices.map(s => `${s.lbl}: ${s.v}`).join(" | ")}>
//       <svg width={44} height={44} viewBox="0 0 44 44">
//         {slices.map(({ k, dash, off, color }) => (
//           <circle key={k} cx={CX} cy={CY} r={R} fill="none"
//             stroke={color} strokeWidth={9}
//             strokeDasharray={`${dash} ${circ - dash}`}
//             strokeDashoffset={off}
//             transform={`rotate(-90 ${CX} ${CY})`}
//           />
//         ))}
//         <circle cx={CX} cy={CY} r={10} fill="#fff"/>
//         <text x={CX} y={CY+4} textAnchor="middle" fontSize="9" fontWeight="700" fill="#374151">
//           {total}
//         </text>
//       </svg>
//     </div>
//   );
// }

// /* ─── Multi-metric toggleable bar chart ─── */
// function MultiBarChart({ rows }) {
//   const [active, setActive] = useState(CHART_METRICS.map(m => m.key));
//   const toggle = (key) =>
//     setActive(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);

//   const visible = CHART_METRICS.filter(m => active.includes(m.key));
//   const maxVal  = Math.max(...rows.flatMap(r => visible.map(m => r[m.key] || 0)), 1);

//   return (
//     <div className="mis-chart-box">
//       <div className="mis-chart-header">
//         <h3>Agent Performance</h3>
//         <div className="mis-chart-legend">
//           {CHART_METRICS.map(m => (
//             <button key={m.key}
//               className={`mis-legend-btn ${active.includes(m.key) ? "on" : "off"}`}
//               onClick={() => toggle(m.key)}
//               style={active.includes(m.key)
//                 ? { borderColor: m.color, color: m.color, background: m.color + "18" }
//                 : {}}
//             >
//               <span className="mis-legend-dot"
//                 style={{ background: active.includes(m.key) ? m.color : "#d1d5db" }}/>
//               {m.label}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="mis-multibar-grid">
//         {rows.map(r => (
//           <div key={r._id} className="mis-multibar-row">
//             <span className="mis-bar-name" title={r.userName}>{r.userName}</span>
//             <div className="mis-multibar-tracks">
//               {visible.map(m => {
//                 const val = r[m.key] || 0;
//                 return (
//                   <div key={m.key} className="mis-mbar-line">
//                     <div className="mis-mbar-label" style={{ color: m.color }}>{m.label}</div>
//                     <div className="mis-mbar-track">
//                       <div className="mis-mbar-fill"
//                         style={{ width: `${(val / maxVal) * 100}%`, background: m.color }}
//                         title={`${m.label}: ${val}`}
//                       />
//                     </div>
//                     <span className="mis-mbar-val" style={{ color: m.color }}>{val}</span>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ─── Main Page ─── */
// export default function MISPage() {
//   const [period,   setPeriod]   = useState("weekly");
//   const [from,     setFrom]     = useState("");
//   const [to,       setTo]       = useState("");
//   const [status,   setStatus]   = useState("All");
//   const [userId,   setUserId]   = useState("");
//   const [users,    setUsers]    = useState([]);
//   const [report,   setReport]   = useState(null);
//   const [loading,  setLoading]  = useState(false);
//   const [expanded, setExpanded] = useState({});
//   const adminFlag = getAdminFlag();

//   useEffect(() => {
//     if (adminFlag) api.get("/users").then(r => setUsers(r.data)).catch(() => {});
//   }, [adminFlag]);

//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const params = { period };
//       if (period === "custom") { params.from = from; params.to = to; }
//       if (status !== "All")    params.status = status;
//       if (userId)              params.userId = userId;
//       const { data } = await fetchMISReport(params);
//       setReport(data);
//       setExpanded({});
//     } catch (err) { console.error(err); }
//     finally { setLoading(false); }
//   }, [period, from, to, status, userId]);

//   useEffect(() => { if (period !== "custom") load(); }, [period, load]);

//   const exportExcel = () => {
//     const token  = localStorage.getItem("token");
//     const params = new URLSearchParams({ period });
//     if (period === "custom" && from) params.append("from",   from);
//     if (period === "custom" && to)   params.append("to",     to);
//     if (status !== "All")            params.append("status", status);
//     if (userId)                      params.append("userId", userId);

//     fetch(`/api/call-logs/mis/export?${params}`, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//       .then(res => { if (!res.ok) throw new Error("Export failed"); return res.blob(); })
//       .then(blob => {
//         const url = URL.createObjectURL(blob);
//         const a   = Object.assign(document.createElement("a"), {
//           href: url,
//           download: `MIS_${period}_${new Date().toISOString().slice(0,10)}.xlsx`,
//         });
//         a.click();
//         URL.revokeObjectURL(url);
//       })
//       .catch(e => alert("Export error: " + e.message));
//   };

//   const toggleRow = (idx) => setExpanded(p => ({ ...p, [idx]: !p[idx] }));

//   const rows    = report?.data || [];
//   const totals  = statMeta.map(m => ({ ...m, value: sumField(rows, m.key) }));

//   return (
//     <div className="mis-page">

//       {/* Header */}
//       <div className="mis-topbar">
//         <div className="mis-heading">
//           <div className="mis-icon-wrap"><BarChart3 size={22}/></div>
//           <div>
//             <h1>MIS Report</h1>
//             <p>Call analytics · Leads · Properties · Deals · Status breakdown</p>
//           </div>
//         </div>
//         <button className="mis-btn-export" onClick={exportExcel}>
//           <Download size={15}/> Export Excel
//         </button>
//       </div>

//       {/* Filters */}
//       <div className="mis-filters-bar">
//         <div className="mis-tabs">
//           {PERIODS.map(p => (
//             <button key={p.value}
//               className={`mis-tab ${period === p.value ? "active" : ""}`}
//               onClick={() => setPeriod(p.value)}>
//               {p.label}
//             </button>
//           ))}
//         </div>

//         {period === "custom" && (
//           <div className="mis-custom-range">
//             <input type="date" value={from} onChange={e => setFrom(e.target.value)}/>
//             <span>→</span>
//             <input type="date" value={to}   onChange={e => setTo(e.target.value)}/>
//           </div>
//         )}

//         <div className="mis-filter-group">
//           <Filter size={13}/>
//           <select value={status} onChange={e => setStatus(e.target.value)}>
//             {STATUS_OPTIONS.map(s => <option key={s}>{s}</option>)}
//           </select>
//         </div>

//         {adminFlag && (
//           <div className="mis-filter-group">
//             <Users size={13}/>
//             <select value={userId} onChange={e => setUserId(e.target.value)}>
//               <option value="">All Agents</option>
//               {users.map(u => (
//                 <option key={u._id} value={u._id}>{u.name || u.Name || u.fullName || u.username || u.email || u._id}</option>
//               ))}
//             </select>
//           </div>
//         )}

//         <button className="mis-btn-apply" onClick={load}>
//           <RefreshCw size={13}/> Apply
//         </button>
//       </div>

//       {report && (
//         <p className="mis-range-label">
//           {new Date(report.from).toLocaleDateString("en-IN")} →{" "}
//           {new Date(report.to).toLocaleDateString("en-IN")}
//           {" · "}{rows.length} agent{rows.length !== 1 ? "s" : ""}
//           {status !== "All" && <> · Status: <strong>{status}</strong></>}
//         </p>
//       )}

//       {loading ? (
//         <div className="mis-loading"><div className="mis-spinner"/><p>Generating report…</p></div>
//       ) : (
//         <>
//           {/* Summary Cards */}
//           <div className="mis-cards">
//             {totals.map(({ key, label, icon: Icon, color, value }) => (
//               <div key={key} className="mis-card">
//                 <div className="mis-card-icon" style={{ background: color + "20", color }}>
//                   <Icon size={20}/>
//                 </div>
//                 <div>
//                   <p className="mis-card-val">{value}</p>
//                   <p className="mis-card-label">{label}</p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Multi-metric chart */}
//           {rows.length > 0 && <MultiBarChart rows={rows}/>}

//           {/* Table */}
//           <div className="mis-table-wrap">
//             {rows.length === 0 ? (
//               <div className="mis-empty">
//                 <BarChart3 size={44} strokeWidth={1}/><p>No data for this period</p>
//               </div>
//             ) : (
//               <table className="mis-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: 32 }}/>
//                     <th>#</th>
//                     <th>Agent</th>
//                     <th>Calls</th>
//                     <th>Leads</th>
//                     <th>Props</th>
//                     <th>Deals</th>
//                     <th>Meetings</th>
//                     <th>Visits</th>
//                     <th>Closed</th>
//                     <th>Status Mix</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rows.map((r, idx) => (
//                     <React.Fragment key={r._id || idx}>
//                       <tr className="mis-main-row" onClick={() => toggleRow(idx)}>
//                         <td className="mis-expand-cell">
//                           {expanded[idx] ? <ChevronDown size={14}/> : <ChevronRight size={14}/>}
//                         </td>
//                         <td className="mis-rank">{idx + 1}</td>
//                         <td>
//                           <div className="mis-user">
//                             <div className="mis-avatar">{r.userName?.[0]?.toUpperCase()}</div>
//                             <div>
//                               <p className="mis-uname">{r.userName}</p>
//                               <p className="mis-uemail">{r.userEmail}</p>
//                             </div>
//                           </div>
//                         </td>
//                         <td><span className="mis-num calls">{r.numberOfCalls}</span></td>
//                         <td><span className="mis-num leads">{r.numberOfLeads}</span></td>
//                         <td><span className="mis-num props">{r.numberOfProperties}</span></td>
//                         <td><span className="mis-num deals">{r.numberOfDeals}</span></td>
//                         <td><span className="mis-num meets">{r.meetingsScheduled}</span></td>
//                         <td><span className="mis-num visits">{r.visits}</span></td>
//                         <td>
//                           <span className={`mis-closed ${r.closedStatus > 0 ? "has" : "zero"}`}>
//                             {r.closedStatus}
//                           </span>
//                         </td>
//                         <td><StatusPie breakdown={r.statusBreakdown}/></td>
//                       </tr>

//                       {expanded[idx] && (
//                         <tr className="mis-detail-row">
//                           <td colSpan={11}>
//                             <div className="mis-detail-grid">

//                               {/* Status breakdown chips */}
//                               {r.statusBreakdown && (
//                                 <div className="mis-detail-section mis-sb-section">
//                                   <h4><BarChart3 size={13}/> Status Breakdown</h4>
//                                   <div className="mis-status-chips">
//                                     {Object.entries(r.statusBreakdown).map(([k, v]) =>
//                                       v > 0 ? (
//                                         <span key={k} className="mis-status-chip"
//                                           style={{
//                                             background: (STATUS_PIE[k] || "#6b7280") + "18",
//                                             color:       STATUS_PIE[k] || "#6b7280",
//                                             border:     `1px solid ${(STATUS_PIE[k] || "#6b7280")}40`,
//                                           }}>
//                                           {STATUS_PIE_LABELS[k] || k}: <strong>{v}</strong>
//                                         </span>
//                                       ) : null
//                                     )}
//                                   </div>
//                                 </div>
//                               )}

//                               {r.leads?.length > 0 && (
//                                 <div className="mis-detail-section">
//                                   <h4><Users size={13}/> Leads ({r.leads.length})</h4>
//                                   {r.leads.filter(Boolean).map(l => (
//                                     <div key={l._id} className="mis-detail-card lead-card">
//                                       <p className="dc-name">{l.name || "—"}</p>
//                                       <p className="dc-sub">
//                                         {l.phone}{l.status && ` · ${l.status}`}{l.interest_level && ` · ⭐ ${l.interest_level}`}
//                                       </p>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}

//                               {r.properties?.length > 0 && (
//                                 <div className="mis-detail-section">
//                                   <h4><Building2 size={13}/> Properties ({r.properties.length})</h4>
//                                   {r.properties.filter(Boolean).map(p => (
//                                     <div key={p._id} className="mis-detail-card prop-card">
//                                       <p className="dc-name">{p.name || "—"}</p>
//                                       <p className="dc-sub">
//                                         {p.location}{p.price && ` · ${fmt(p.price)}`}{p.status && ` · ${p.status}`}
//                                       </p>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}

//                               {r.deals?.length > 0 && (
//                                 <div className="mis-detail-section">
//                                   <h4><TrendingUp size={13}/> Deals ({r.deals.length})</h4>
//                                   {r.deals.filter(Boolean).map(d => {
//                                     const sc = STAGE_COLOR[d.stage] || { bg: "#f3f4f6", color: "#374151" };
//                                     return (
//                                       <div key={d._id} className="mis-detail-card deal-card">
//                                         <div className="dc-deal-top">
//                                           <p className="dc-name">{d.name || "—"}</p>
//                                           <span className="dc-stage" style={{ background: sc.bg, color: sc.color }}>{d.stage}</span>
//                                         </div>
//                                         <p className="dc-sub">
//                                           {d.dealValue && <><IndianRupee size={11}/>{Number(d.dealValue).toLocaleString("en-IN")}</>}
//                                           {d.expectedCloseDate && ` · Close: ${new Date(d.expectedCloseDate).toLocaleDateString()}`}
//                                           {d.agreementSigned && " · ✓ Signed"}
//                                         </p>
//                                       </div>
//                                     );
//                                   })}
//                                 </div>
//                               )}

//                               {(!r.leads?.length && !r.properties?.length && !r.deals?.length && !r.statusBreakdown) && (
//                                 <p className="mis-detail-empty">No linked entities for this agent in this period.</p>
//                               )}
//                             </div>
//                           </td>
//                         </tr>
//                       )}
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//                 <tfoot>
//                   <tr className="mis-total-row">
//                     <td colSpan={3}><strong>Total</strong></td>
//                     {statMeta.map(m => (
//                       <td key={m.key}><strong>{sumField(rows, m.key)}</strong></td>
//                     ))}
//                     <td/>
//                   </tr>
//                 </tfoot>
//               </table>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  BarChart3, Phone, Users, Building2, Calendar,
  CheckCircle2, TrendingUp, Download, RefreshCw,
  ChevronDown, ChevronRight, ChevronLeft, IndianRupee, Filter,
  Search, X, SortAsc, SortDesc, MousePointerClick, Loader2,
  FileText, Wallet, ClipboardCheck, MapPin,
} from "lucide-react";
import { fetchMISReport, fetchMISReportDetails, fetchMISDashboard, fetchMISModuleDetails } from "../callLogApi";
import { formatCallStatus } from "../utils/callStatusLabels";
import api from "../api/api";
import "./MISPage.css";
import "../css/reports/misReportModern.css";

/* ─── Constants ─── */
const PERIODS = [
  { label: "Daily",   value: "daily"   },
  { label: "Weekly",  value: "weekly"  },
  { label: "Monthly", value: "monthly" },
  { label: "Custom",  value: "custom"  },
];

const STATUS_OPTIONS = ["All","Not Answering","New","Interested","Negotiating","Closed","Not Interested","Follow-up"];

const SORT_OPTIONS = [
  { label: "Agent Name",  value: "name"         },
  { label: "Calls",       value: "numberOfCalls" },
  { label: "Closed",      value: "closed"        },
];

const statMeta = [
  { key: "numberOfCalls",       label: "Total Calls",    icon: Phone,        color: "#6366f1", callStatus: undefined         },
  { key: "statusNotAnswering",  label: "Not Answered",   icon: CheckCircle2, color: "#94a3b8", callStatus: "Not Answering"   },
  { key: "statusInterested",    label: "Interested",     icon: CheckCircle2, color: "#10b981", callStatus: "Interested"      },
  { key: "statusNotInterested", label: "Not Interested", icon: CheckCircle2, color: "#ef4444", callStatus: "Not Interested"  },
  { key: "statusFollowup",      label: "Follow-up List", icon: CheckCircle2, color: "#8b5cf6", callStatus: "Follow-up"       },
];

/* Cross-module totals — one card per CRM module, pulled from the MIS dashboard
   endpoint (real per-module collection totals, not CallLog-linked proxies). */
const moduleMeta = [
  { key: "leadsCreated",       label: "Leads Created",     icon: Users,          color: "#6366f1", moduleKey: "leads"      },
  { key: "propertiesListed",   label: "Properties Listed", icon: Building2,      color: "#f59e0b", moduleKey: "properties" },
  { key: "dealsWon",           label: "Deals Won",         icon: TrendingUp,     color: "#22c55e", moduleKey: "deals"      },
  { key: "paymentsReceived",   label: "Payments Received", icon: Wallet,         color: "#10b981", moduleKey: "payments",  isCurrency: true },
  { key: "documentsUploaded",  label: "Documents",         icon: FileText,       color: "#8b5cf6", moduleKey: "documents"  },
  { key: "tasksCompleted",     label: "Tasks Completed",   icon: ClipboardCheck, color: "#0ea5e9", moduleKey: "tasks"      },
  { key: "clientVisitsTotal",  label: "Site Visits",       icon: MapPin,         color: "#06b6d4", moduleKey: "visits"     },
  { key: "meetingsScheduled",  label: "Meetings",          icon: Calendar,       color: "#ec4899", moduleKey: "meetings"   },
];

const STAGE_COLOR = {
  negotiation:     { bg: "#fef9c3", color: "#a16207" },
  documentation:   { bg: "#dbeafe", color: "#1d4ed8" },
  payment_pending: { bg: "#fee2e2", color: "#dc2626" },
  closed_won:      { bg: "#dcfce7", color: "#15803d" },
  closed_lost:     { bg: "#f3f4f6", color: "#6b7280" },
};

const STATUS_PIE = {
  NotAnswering:"#94a3b8", New:"#6366f1", Interested:"#10b981",
  Negotiating:"#f59e0b", Closed:"#22c55e", NotInterested:"#ef4444", Followup:"#8b5cf6",
};
const STATUS_PIE_LABELS = {
  NotAnswering:"Not Answered", New:"New", Interested:"Interested",
  Negotiating:"Negotiating", Closed:"Closed", NotInterested:"Not Interested", Followup:"Follow-up List",
};

/* Maps the raw `currentStatus` string stored on a call log to its STATUS_PIE color key */
const CALL_STATUS_TO_PIE_KEY = {
  "Not Answering":  "NotAnswering",
  "New":            "New",
  "Interested":     "Interested",
  "Negotiating":    "Negotiating",
  "Not Interested": "NotInterested",
  "Follow-up":      "Followup",
  "Closed":         "Closed",
};
/* Inverse of CALL_STATUS_TO_PIE_KEY — used when a status chip is clicked to drill down */
const PIE_KEY_TO_CALL_STATUS = Object.fromEntries(
  Object.entries(CALL_STATUS_TO_PIE_KEY).map(([status, key]) => [key, status])
);

const PIE_METRICS = [
  { key: "statusNotAnswering",  label: "Not Answered",   color: "#94a3b8", callStatus: "Not Answering"  },
  { key: "statusInterested",    label: "Interested",     color: "#10b981", callStatus: "Interested"     },
  { key: "statusNotInterested", label: "Not Interested", color: "#ef4444", callStatus: "Not Interested" },
  { key: "statusFollowup",      label: "Follow-up List", color: "#8b5cf6", callStatus: "Follow-up"      },
];

/* ─── Helpers ─── */
const sumField = (data, key) => data.reduce((a, r) => a + (r[key] || 0), 0);
const fmt      = (n) => n ? `₹${Number(n).toLocaleString("en-IN")}` : "—";
const toISODate = (d) => {
  const z = new Date(d);
  z.setMinutes(z.getMinutes() - z.getTimezoneOffset());
  return z.toISOString().slice(0, 10);
};
const addDays = (date, n) => { const d = new Date(date); d.setDate(d.getDate() + n); return d; };

/**
 * The MIS "weekly" period is always the 6-day working week Wednesday → Monday
 * that contains `anchor` — matches the backend's Tuesday cron digest range.
 */
function getWedMonRange(anchor) {
  const d = new Date(anchor);
  const daysSinceWed = (d.getDay() - 3 + 7) % 7; // Sun=0..Sat=6, Wed=3
  const start = new Date(d);
  start.setDate(start.getDate() - daysSinceWed);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 5); // Wed + 5 = Mon
  end.setHours(23, 59, 59, 999);
  return { start, end };
}

function getAdminFlag() {
  try {
    const p = JSON.parse(atob(localStorage.getItem("token").split(".")[1]));
    return p.role === "admin" || p.role === "superadmin" || p.isAdmin === true;
  } catch { return false; }
}

function nameFromEmail(email) {
  if (!email) return null;
  return email.split("@")[0]
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[._-]+/g, " ")
    .split(" ")
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

function resolveAgent(r, usersMap = {}) {
  const fallback  = usersMap[r._id] || usersMap[r.userId] || {};
  const email     = r.userEmail || fallback.email || null;
  const rawName   = r.userName || "";
  const isGeneric = !rawName || ["admin", "unknown agent", "unknown"].includes(rawName.toLowerCase());
  const name      = (!isGeneric ? rawName : null) || nameFromEmail(email) || rawName || "Unknown Agent";
  return { name, email: email || "—", letter: name[0]?.toUpperCase() || "?" };
}

/* ─── SVG Status Donut (table column) ─── */
function StatusPie({ breakdown }) {
  if (!breakdown) return <span className="mis-pie-empty">—</span>;
  const entries = Object.entries(breakdown).filter(([, v]) => v > 0);
  const total   = entries.reduce((s, [, v]) => s + v, 0);
  if (!total)    return <span className="mis-pie-empty">—</span>;

  const R = 17, CX = 22, CY = 22;
  const circ = 2 * Math.PI * R;
  let cum = 0;
  const slices = entries.map(([k, v]) => {
    const pct = v / total, dash = pct * circ, off = circ - cum * circ;
    cum += pct;
    return { k, dash, off, color: STATUS_PIE[k] || "#ccc", v, lbl: STATUS_PIE_LABELS[k] || k };
  });

  return (
    <div className="mis-pie-wrap" title={slices.map(s => `${s.lbl}: ${s.v}`).join(" | ")}>
      <svg width={44} height={44} viewBox="0 0 44 44">
        {slices.map(({ k, dash, off, color }) => (
          <circle key={k} cx={CX} cy={CY} r={R} fill="none"
            stroke={color} strokeWidth={9}
            strokeDasharray={`${dash} ${circ - dash}`}
            strokeDashoffset={off}
            transform={`rotate(-90 ${CX} ${CY})`}
          />
        ))}
        <circle cx={CX} cy={CY} r={10} fill="#fff"/>
        <text x={CX} y={CY+4} textAnchor="middle" fontSize="9" fontWeight="700" fill="#374151">{total}</text>
      </svg>
    </div>
  );
}

/* ─── Single Donut SVG (large, for chart section) ─── */
function DonutChart({ slices, total, label, size = 160, strokeW = 28 }) {
  const R = (size - strokeW) / 2, CX = size / 2, CY = size / 2;
  const circ = 2 * Math.PI * R;

  if (!total) return (
    <svg width={size} height={size}>
      <circle cx={CX} cy={CY} r={R} fill="none" stroke="#f3f4f6" strokeWidth={strokeW}/>
      <text x={CX} y={CY - 6} textAnchor="middle" fontSize="13" fill="#9ca3af">No</text>
      <text x={CX} y={CY + 10} textAnchor="middle" fontSize="13" fill="#9ca3af">data</text>
    </svg>
  );

  let cum = 0;
  const drawn = slices.filter(s => s.value > 0).map(s => {
    const pct = s.value / total, dash = pct * circ, off = circ - cum * circ;
    cum += pct;
    return { ...s, dash, off };
  });

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {drawn.map((s, i) => (
        <circle key={i} cx={CX} cy={CY} r={R} fill="none"
          stroke={s.color} strokeWidth={strokeW}
          strokeDasharray={`${s.dash} ${circ - s.dash}`}
          strokeDashoffset={s.off}
          transform={`rotate(-90 ${CX} ${CY})`}>
          <title>{s.label}: {s.value}</title>
        </circle>
      ))}
      <circle cx={CX} cy={CY} r={R - strokeW / 2 - 2} fill="#fff"/>
      <text x={CX} y={CY - 8} textAnchor="middle" fontSize="22" fontWeight="800" fill="#111827">{total}</text>
      <text x={CX} y={CY + 10} textAnchor="middle" fontSize="11" fill="#6b7280">{label}</text>
    </svg>
  );
}

/* ─── Pie Chart Section ─── */
function PieChartSection({ rows, usersMap = {}, period, openDetails }) {
  const [activeMetrics, setActiveMetrics] = useState(PIE_METRICS.map(m => m.key));
  const toggle = (key) =>
    setActiveMetrics(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
  const visible = PIE_METRICS.filter(m => activeMetrics.includes(m.key));
  const combinedSlices = visible.map(m => ({ label: m.label, color: m.color, value: sumField(rows, m.key) }));
  const combinedTotal  = combinedSlices.reduce((s, sl) => s + sl.value, 0);
  const periodLabel = period ? period.charAt(0).toUpperCase() + period.slice(1) : "";

  const openMetricDetails = (agentName, agentKey, m, value) => openDetails({
    title: `${agentName} — ${m.label}`,
    subtitle: `${periodLabel} · ${value} record${value !== 1 ? "s" : ""}`,
    callStatus: m.callStatus,
    agentKey,
  });

  const openAllDetails = (agentName, agentKey, total) => openDetails({
    title: `${agentName} — All Calls`,
    subtitle: `${periodLabel} · ${total} record${total !== 1 ? "s" : ""}`,
    agentKey,
  });

  return (
    <div className="mis-chart-box">
      <div className="mis-chart-header">
        <h3>Call Status Distribution — Per Agent</h3>
        <div className="mis-chart-legend">
          {PIE_METRICS.map(m => (
            <button key={m.key}
              className={`mis-legend-btn ${activeMetrics.includes(m.key) ? "on" : "off"}`}
              onClick={() => toggle(m.key)}
              style={activeMetrics.includes(m.key) ? { borderColor: m.color, color: m.color, background: m.color + "18" } : {}}>
              <span className="mis-legend-dot" style={{ background: activeMetrics.includes(m.key) ? m.color : "#d1d5db" }}/>
              {m.label}
            </button>
          ))}
        </div>
      </div>
      <div className="mis-pie-charts-grid">
        <div className="mis-pie-agent-card mis-pie-combined">
          <div className="mis-pie-donut mis-clickable"
            title="View all call records across every agent"
            onClick={() => openAllDetails("All Agents", undefined, combinedTotal)}>
            <DonutChart slices={combinedSlices} total={combinedTotal} label="Total" size={160} strokeW={28}/>
          </div>
          <p className="mis-pie-agent-name">All Agents</p>
          <div className="mis-pie-legend-list">
            {visible.map(m => {
              const val = sumField(rows, m.key);
              return (
                <div key={m.key} className="mis-pie-legend-item mis-clickable"
                  title={`View the ${val} "${m.label}" calls across every agent`}
                  onClick={() => openMetricDetails("All Agents", undefined, m, val)}>
                  <span className="mis-pie-legend-dot" style={{ background: m.color }}/>
                  <span className="mis-pie-legend-label">{m.label}</span>
                  <span className="mis-pie-legend-val" style={{ color: m.color }}>{val}</span>
                </div>
              );
            })}
          </div>
        </div>
        {rows.map((r, i) => {
          const { name: agentName } = resolveAgent(r, usersMap);
          const agentSlices = visible.map(m => ({ label: m.label, color: m.color, value: r[m.key] || 0 }));
          const agentTotal  = agentSlices.reduce((s, sl) => s + sl.value, 0);
          return (
            <div key={r._id || i} className="mis-pie-agent-card">
              <div className="mis-pie-donut mis-clickable"
                title={`View all ${agentTotal} calls for ${agentName}`}
                onClick={() => openAllDetails(agentName, r._id, agentTotal)}>
                <DonutChart slices={agentSlices} total={agentTotal} label="total" size={140} strokeW={24}/>
              </div>
              <p className="mis-pie-agent-name">{agentName}</p>
              <div className="mis-pie-legend-list">
                {visible.map(m => {
                  const val = r[m.key] || 0;
                  if (!val) return null;
                  return (
                    <div key={m.key} className="mis-pie-legend-item mis-clickable"
                      title={`View the ${val} "${m.label}" calls for ${agentName}`}
                      onClick={() => openMetricDetails(agentName, r._id, m, val)}>
                      <span className="mis-pie-legend-dot" style={{ background: m.color }}/>
                      <span className="mis-pie-legend-label">{m.label}</span>
                      <span className="mis-pie-legend-val" style={{ color: m.color }}>{val}</span>
                    </div>
                  );
                })}
                {agentTotal === 0 && <p style={{ fontSize: "0.75rem", color: "#9ca3af", margin: 0 }}>No activity</p>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ─── Active Filter Chips ─── */
function FilterChips({ search, status, userId, users, sortBy, sortDir, userRole, onClear }) {
  const chips = [];
  if (search)           chips.push({ id: "search",  label: `Search: "${search}"`,       onRemove: () => onClear("search")  });
  if (status !== "All") chips.push({ id: "status",  label: `Status: ${status}`,          onRemove: () => onClear("status")  });
  // Show agent chip only for managers/superadmins who manually selected an agent
  if (userId && userRole !== "agent") {
    const u = users.find(u => u._id === userId);
    const name = u ? (u.name || u.Name || u.fullName || u.username || u.email || userId) : userId;
    chips.push({ id: "agent", label: `Agent: ${name}`, onRemove: () => onClear("agent") });
  }
  if (sortBy !== "name") chips.push({ id: "sort", label: `Sort: ${SORT_OPTIONS.find(o => o.value === sortBy)?.label} ${sortDir === "asc" ? "↑" : "↓"}`, onRemove: () => onClear("sort") });
  if (!chips.length) return null;

  return (
    <div className="mis-active-chips">
      {chips.map(c => (
        <span key={c.id} className="mis-active-chip">
          {c.label}
          <button className="mis-chip-x" onClick={c.onRemove}><X size={11}/></button>
        </span>
      ))}
      <button className="mis-clear-all" onClick={() => onClear("all")}>Clear all</button>
    </div>
  );
}

/* ─── Drill-down modal: raw call records behind a clicked stat/status/count ─── */
function MISDetailsModal({ title, subtitle, params, onClose }) {
  const [rows,    setRows]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchMISReportDetails(params)
      .then(({ data }) => { if (!cancelled) setRows(data?.data || []); })
      .catch((err) => { if (!cancelled) setError(err.response?.data?.message || "Failed to load records"); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return (
    <div className="mis-modal-overlay" onClick={onClose}>
      <div className="mis-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mis-modal-header">
          <div>
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button className="mis-modal-close" onClick={onClose}><X size={16}/></button>
        </div>

        <div className="mis-modal-body">
          {loading ? (
            <div className="mis-modal-loading"><Loader2 size={22} className="mis-spin-icon"/><span>Loading records…</span></div>
          ) : error ? (
            <div className="mis-modal-empty">{error}</div>
          ) : rows.length === 0 ? (
            <div className="mis-modal-empty">No matching call records for this selection.</div>
          ) : (
            <div className="mis-modal-table-wrap">
              <table className="mis-modal-table">
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>Contact</th>
                    <th>Agent</th>
                    <th>Status</th>
                    <th>Call Date</th>
                    <th>Linked</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r._id}>
                      <td>{r.clientName || "—"}</td>
                      <td>{r.contactNumber || "—"}</td>
                      <td>{r.createdByName || "—"}</td>
                      <td>
                        {(() => {
                          const pieColor = STATUS_PIE[CALL_STATUS_TO_PIE_KEY[r.currentStatus]] || "#6b7280";
                          return (
                            <span className="mis-status-chip" style={{ background: pieColor + "18", color: pieColor }}>
                              {formatCallStatus(r.currentStatus)}
                            </span>
                          );
                        })()}
                      </td>
                      <td>{r.callDate ? new Date(r.callDate).toLocaleDateString("en-IN") : "—"}</td>
                      <td>{[r.lead && `Lead: ${r.lead}`, r.property && `Prop: ${r.property}`, r.deal && `Deal: ${r.deal}`].filter(Boolean).join(" · ") || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="mis-modal-footer">
          <span>{loading ? "…" : `${rows.length} record${rows.length !== 1 ? "s" : ""}`}</span>
          <button className="mis-btn-apply" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

/* ─── Drill-down modal: raw records behind an "All Modules" card ─── */
function ModuleDetailsModal({ title, subtitle, params, onClose }) {
  const [rows,    setRows]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchMISModuleDetails(params)
      .then(({ data }) => { if (!cancelled) setRows(data?.data || []); })
      .catch((err) => { if (!cancelled) setError(err.response?.data?.message || "Failed to load records"); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return (
    <div className="mis-modal-overlay" onClick={onClose}>
      <div className="mis-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mis-modal-header">
          <div>
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button className="mis-modal-close" onClick={onClose}><X size={16}/></button>
        </div>

        <div className="mis-modal-body">
          {loading ? (
            <div className="mis-modal-loading"><Loader2 size={22} className="mis-spin-icon"/><span>Loading records…</span></div>
          ) : error ? (
            <div className="mis-modal-empty">{error}</div>
          ) : rows.length === 0 ? (
            <div className="mis-modal-empty">No matching records for this selection.</div>
          ) : (
            <div className="mis-modal-table-wrap">
              <table className="mis-modal-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Detail</th>
                    <th>Status</th>
                    <th>Info</th>
                    <th>Agent</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={i}>
                      <td>{r.name || "—"}</td>
                      <td>{r.detail || "—"}</td>
                      <td>
                        <span className="mis-status-chip" style={{ background: "#6366f118", color: "#6366f1" }}>
                          {r.status || "—"}
                        </span>
                      </td>
                      <td>{r.extra || "—"}</td>
                      <td>{r.agent || "—"}</td>
                      <td>{r.date ? new Date(r.date).toLocaleDateString("en-IN") : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="mis-modal-footer">
          <span>{loading ? "…" : `${rows.length} record${rows.length !== 1 ? "s" : ""}`}</span>
          <button className="mis-btn-apply" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

/* ─── Main Page ─── */
export default function MISPage() {
  const [period,   setPeriod]   = useState("weekly");
  const [from,     setFrom]     = useState("");
  const [to,       setTo]       = useState("");
  const [status,   setStatus]   = useState("All");
  const [userId,   setUserId]   = useState("");
  const [search,   setSearch]   = useState("");
  const [sortBy,   setSortBy]   = useState("name");
  const [sortDir,  setSortDir]  = useState("asc");
  const [users,    setUsers]    = useState([]);
  const [report,   setReport]   = useState(null);
  const [dashboard, setDashboard] = useState(null); // cross-module totals (Leads/Properties/Deals/Payments/Documents/Tasks/Visits)
  const [loading,  setLoading]  = useState(false);
  const [expanded, setExpanded] = useState({});
  const [weekAnchor, setWeekAnchor] = useState(() => new Date());
  const [detailModal, setDetailModal] = useState(null); // { title, subtitle, params } | null
  const [moduleDetailModal, setModuleDetailModal] = useState(null); // { title, subtitle, params } | null
  const adminFlag = getAdminFlag();

  // The current Wed–Mon window for the "Weekly" tab; recomputed only when weekAnchor moves
  const weeklyRange = useMemo(() => getWedMonRange(weekAnchor), [weekAnchor]);
  const canGoNextWeek = weeklyRange.start < getWedMonRange(new Date()).start;

  /* ── "All Modules" card row has its own independent Daily/Weekly/Monthly/Custom
        filter, separate from the page-level filter bar above ── */
  const [modPeriod,     setModPeriod]     = useState("weekly");
  const [modWeekAnchor, setModWeekAnchor] = useState(() => new Date());
  const [modFrom,       setModFrom]       = useState("");
  const [modTo,         setModTo]         = useState("");
  const [modAgent,      setModAgent]      = useState("");
  const [moduleOverview,        setModuleOverview]        = useState(null);
  const [moduleOverviewLoading, setModuleOverviewLoading] = useState(false);

  const modWeeklyRange   = useMemo(() => getWedMonRange(modWeekAnchor), [modWeekAnchor]);
  const modCanGoNextWeek = modWeeklyRange.start < getWedMonRange(new Date()).start;
  const modCustomIncomplete = modPeriod === "custom" && (!modFrom || !modTo);

  const [userRole, setUserRole] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);

  // Extract user role and ID from token
  // JWT stores user ID as "id", not "_id"
  useEffect(() => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        const payload = JSON.parse(atob(token.split(".")[1]));
        const extractedId = payload.id || payload._id;
        setUserRole(payload.role);
        setCurrentUserId(extractedId);
        // If agent, auto-set userId to their own
        if (payload.role === "agent" && extractedId) {
          setUserId(extractedId);
        }
      }
    } catch (e) {
      console.error("Error decoding token:", e);
    }
  }, []);

  // Only managers/superadmins need the full users list (for agent dropdown filter)
  useEffect(() => {
    if (userRole === "admin" || userRole === "superadmin") {
      api.get("/users")
        .then(r => { const list = r.data || []; setUsers(list); })
        .catch(() => {});
    }
  }, [userRole]);

  // Custom range requires both dates — never silently fall back to a different window
  const customRangeIncomplete = period === "custom" && (!from || !to);

  const load = useCallback(async () => {
    if (customRangeIncomplete) { setReport(null); return; }
    setLoading(true);
    try {
      const params = { period };
      if (period === "custom") {
        params.from = from; params.to = to;
      } else if (period === "weekly") {
        params.from = toISODate(weeklyRange.start); params.to = toISODate(weeklyRange.end);
      }
      if (status !== "All")    params.status = status;
      if (userId)              params.userId = userId;

      const [{ data }, dashboardRes] = await Promise.all([
        fetchMISReport(params),
        fetchMISDashboard(params).catch((err) => { console.error("MIS dashboard fetch failed:", err); return null; }),
      ]);
      setReport(data);
      setDashboard(dashboardRes?.data || null);
      setExpanded({});
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, [period, from, to, status, userId, weeklyRange, customRangeIncomplete]);

  useEffect(() => { if (period !== "custom") load(); }, [period, load]);

  const handlePeriodChange = (value) => {
    setPeriod(value);
    if (value === "weekly") setWeekAnchor(new Date());
  };

  /* ── "All Modules" card row — independent fetch, own period/agent filter ── */
  const loadModuleOverview = useCallback(async () => {
    if (modCustomIncomplete) { setModuleOverview(null); return; }
    setModuleOverviewLoading(true);
    try {
      const params = { period: modPeriod };
      if (modPeriod === "custom") {
        params.from = modFrom; params.to = modTo;
      } else if (modPeriod === "weekly") {
        params.from = toISODate(modWeeklyRange.start); params.to = toISODate(modWeeklyRange.end);
      }
      if (modAgent) params.userId = modAgent;
      const { data } = await fetchMISDashboard(params);
      setModuleOverview(data);
    } catch (err) {
      console.error("Module overview fetch failed:", err);
      setModuleOverview(null);
    } finally {
      setModuleOverviewLoading(false);
    }
  }, [modPeriod, modFrom, modTo, modAgent, modWeeklyRange, modCustomIncomplete]);

  useEffect(() => { if (modPeriod !== "custom") loadModuleOverview(); }, [modPeriod, loadModuleOverview]);

  const handleModPeriodChange = (value) => {
    setModPeriod(value);
    if (value === "weekly") setModWeekAnchor(new Date());
  };

  // Uses the "All Modules" section's OWN period/agent filter — independent of
  // the page-level filter bar that drives the call-log table above it.
  const openModuleDetails = (moduleKey, title) => {
    const params = { module: moduleKey, period: modPeriod };
    if (modPeriod === "custom") { params.from = modFrom; params.to = modTo; }
    else if (modPeriod === "weekly") { params.from = toISODate(modWeeklyRange.start); params.to = toISODate(modWeeklyRange.end); }
    if (modAgent) params.userId = modAgent;
    setModuleDetailModal({
      title,
      subtitle: `${modPeriod.charAt(0).toUpperCase() + modPeriod.slice(1)}`,
      params,
    });
  };

  const openDetails = ({ title, subtitle, callStatus, agentKey }) => {
    const params = { period };
    if (period === "custom") { params.from = from; params.to = to; }
    else if (period === "weekly") { params.from = toISODate(weeklyRange.start); params.to = toISODate(weeklyRange.end); }
    if (callStatus)                     params.status = callStatus;
    else if (status !== "All")          params.status = status;
    if (agentKey)                       params.agentKey = agentKey;
    else if (userId)                    params.userId = userId;
    setDetailModal({ title, subtitle, params });
  };

  const exportExcel = () => {
    const token  = localStorage.getItem("token");
    const params = new URLSearchParams({ period });
    if (period === "custom") {
      if (from) params.append("from", from);
      if (to)   params.append("to",   to);
    } else if (period === "weekly") {
      params.append("from", toISODate(weeklyRange.start));
      params.append("to",   toISODate(weeklyRange.end));
    }
    if (status !== "All")            params.append("status", status);
    if (userId)                      params.append("userId", userId);
    // Full cross-module workbook (Calls/Leads/Properties/Deals/Payments/Documents/
    // Tasks/Visits) — the same multi-sheet export the weekly email attaches.
    fetch(`/api/reports/mis-dashboard/export?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => { if (!res.ok) throw new Error("Export failed"); return res.blob(); })
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a   = Object.assign(document.createElement("a"), {
          href: url,
          download: `MIS_${period}_${new Date().toISOString().slice(0,10)}.xlsx`,
        });
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(e => alert("Export error: " + e.message));
  };

  const toggleRow = (idx) => setExpanded(p => ({ ...p, [idx]: !p[idx] }));

  const usersMap = Object.fromEntries(users.map(u => [u._id, u]));
  const rawRows  = report?.data || [];

  // Cross-module rows, keyed by lowercased email so they can be matched
  // against the call-log rows above (which use a different grouping key).
  const dashboardRows = dashboard?.data || [];
  const dashboardMap  = Object.fromEntries(
    dashboardRows.filter(r => r.userEmail).map(r => [r.userEmail.toLowerCase(), r])
  );
  const moduleOverviewRows = moduleOverview?.data || [];
  const moduleTotals = moduleMeta.map(m => ({ ...m, value: sumField(moduleOverviewRows, m.key) }));

  /* ── Client-side search + sort ── */
  const rows = useMemo(() => {
    let filtered = rawRows;

    // Search filter — name or email
    if (search.trim()) {
      const q = search.trim().toLowerCase();
      filtered = filtered.filter(r => {
        const { name, email } = resolveAgent(r, usersMap);
        return name.toLowerCase().includes(q) || email.toLowerCase().includes(q);
      });
    }

    // Sort
    filtered = [...filtered].sort((a, b) => {
      let aVal, bVal;
      if (sortBy === "name") {
        aVal = resolveAgent(a, usersMap).name.toLowerCase();
        bVal = resolveAgent(b, usersMap).name.toLowerCase();
        return sortDir === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
      }
      aVal = a[sortBy] || 0;
      bVal = b[sortBy] || 0;
      return sortDir === "asc" ? aVal - bVal : bVal - aVal;
    });

    return filtered;
  }, [rawRows, search, sortBy, sortDir, usersMap]);

  const totals     = statMeta.map(m => ({ ...m, value: sumField(rows, m.key) }));

  const handleClearChip = (id) => {
    if (id === "search") setSearch("");
    if (id === "status") setStatus("All");
    // Agents cannot clear their own userId filter — they always view their own data
    if (id === "agent"  && userRole !== "agent") setUserId("");
    if (id === "sort")   { setSortBy("name"); setSortDir("asc"); }
    if (id === "all") {
      setSearch(""); setStatus("All"); setSortBy("name"); setSortDir("asc");
      if (userRole !== "agent") setUserId("");
    }
  };

  const toggleSort = (col) => {
    if (sortBy === col) setSortDir(d => d === "asc" ? "desc" : "asc");
    else { setSortBy(col); setSortDir("desc"); }
  };

  const SortIcon = ({ col }) => {
    if (sortBy !== col) return null;
    return sortDir === "asc" ? <SortAsc size={11} style={{ marginLeft: 3 }}/> : <SortDesc size={11} style={{ marginLeft: 3 }}/>;
  };

  return (
    <div className="mis-page">

      {/* ── Header ── */}
      <div className="mis-topbar">
        <div className="mis-heading">
          <div className="mis-icon-wrap"><BarChart3 size={22}/></div>
          <div>
            <h1>MIS Report {userRole === "agent" && "· Your Data"}</h1>
            <p>
              {userRole === "agent"
                ? "Your assigned leads, deals, and activities"
                : "Call analytics · Leads · Properties · Deals · Status breakdown"}
            </p>
          </div>
        </div>
        <button className="mis-btn-export" onClick={exportExcel}>
          <Download size={15}/> Export Excel
        </button>
      </div>

      {/* ── Filters Bar ── */}
      <div className="mis-filters-bar">

        {/* Period tabs */}
        <div className="mis-tabs">
          {PERIODS.map(p => (
            <button key={p.value}
              className={`mis-tab ${period === p.value ? "active" : ""}`}
              onClick={() => handlePeriodChange(p.value)}>
              {p.label}
            </button>
          ))}
        </div>

        {/* Weekly Wed→Mon range, with prev/next week navigation */}
        {period === "weekly" && (
          <div className="mis-week-nav">
            <button className="mis-week-nav-btn" onClick={() => setWeekAnchor(d => addDays(d, -7))} title="Previous week">
              <ChevronLeft size={14}/>
            </button>
            <span className="mis-week-nav-label">
              {weeklyRange.start.toLocaleDateString("en-IN", { day: "2-digit", month: "short" })}
              {" (Wed) → "}
              {weeklyRange.end.toLocaleDateString("en-IN", { day: "2-digit", month: "short" })}
              {" (Mon)"}
            </span>
            <button className="mis-week-nav-btn" onClick={() => setWeekAnchor(d => addDays(d, 7))}
              disabled={!canGoNextWeek} title="Next week">
              <ChevronRight size={14}/>
            </button>
          </div>
        )}

        {/* Custom date range */}
        {period === "custom" && (
          <div className="mis-custom-range">
            <input type="date" value={from} onChange={e => setFrom(e.target.value)}/>
            <span>→</span>
            <input type="date" value={to}   onChange={e => setTo(e.target.value)}/>
            {customRangeIncomplete && <span className="mis-custom-range-hint">Pick both dates</span>}
          </div>
        )}

        {/* Status filter */}
        <div className="mis-filter-group">
          <Filter size={13}/>
          <select value={status} onChange={e => setStatus(e.target.value)}>
            {STATUS_OPTIONS.map(s => <option key={s} value={s}>{formatCallStatus(s)}</option>)}
          </select>
        </div>

        {/* Agent filter (admin only) */}
        {adminFlag && (
          <div className="mis-filter-group">
            <Users size={13}/>
            <select value={userId} onChange={e => setUserId(e.target.value)}>
              <option value="">All Agents</option>
              {users.map(u => (
                <option key={u._id} value={u._id}>
                  {u.name || u.Name || u.fullName || u.username || u.email || u._id}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Agent view indicator (agents only) */}
        {userRole === "agent" && (
          <div className="mis-agent-view-indicator">
            <Users size={12}/>
            <span>Viewing your data</span>
          </div>
        )}

        {/* Sort by */}
        <div className="mis-filter-group">
          {sortDir === "asc" ? <SortAsc size={13}/> : <SortDesc size={13}/>}
          <select value={sortBy} onChange={e => { setSortBy(e.target.value); setSortDir("desc"); }}>
            {SORT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          <button className="mis-sort-dir-btn" onClick={() => setSortDir(d => d === "asc" ? "desc" : "asc")}
            title="Toggle sort direction" style={{ background: "none", border: "none", cursor: "pointer", padding: "0 2px", color: "#6b7280" }}>
            {sortDir === "asc" ? "↑" : "↓"}
          </button>
        </div>

        {/* Search bar */}
        <div className="mis-search-box">
          <Search size={13} className="mis-search-icon"/>
          <input
            type="text"
            className="mis-search-input"
            placeholder="Search agent name or email…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          {search && (
            <button className="mis-search-clear" onClick={() => setSearch("")}><X size={11}/></button>
          )}
        </div>

        <button className="mis-btn-apply" onClick={load} disabled={customRangeIncomplete}>
          <RefreshCw size={13}/> Apply
        </button>
      </div>

      {/* ── Active filter chips ── */}
      <FilterChips
        search={search} status={status} userId={userId} users={users}
        sortBy={sortBy} sortDir={sortDir} userRole={userRole}
        onClear={handleClearChip}
      />

      {/* ── Date range label ── */}
      {report && (
        <p className="mis-range-label">
          {new Date(report.from).toLocaleDateString("en-IN")} →{" "}
          {new Date(report.to).toLocaleDateString("en-IN")}
          {" · "}{rows.length} of {rawRows.length} agent{rawRows.length !== 1 ? "s" : ""}
          {status !== "All" && <> · Status: <strong>{status}</strong></>}
          {search && <> · Filtered by: <strong>"{search}"</strong></>}
        </p>
      )}

      {customRangeIncomplete ? (
        <div className="mis-empty">
          <Calendar size={44} strokeWidth={1}/>
          <p>Select both a "From" and "To" date to generate the custom report.</p>
        </div>
      ) : loading ? (
        <div className="mis-loading"><div className="mis-spinner"/><p>Generating report…</p></div>
      ) : (
        <>
          {/* Summary Cards — click any card to see the underlying call records */}
          <div className="mis-cards">
            {totals.map(({ key, label, icon: Icon, color, value, callStatus }) => (
              <div key={key} className="mis-card mis-clickable"
                onClick={() => openDetails({
                  title: label,
                  subtitle: `${period.charAt(0).toUpperCase() + period.slice(1)} · ${value} record${value !== 1 ? "s" : ""}`,
                  callStatus,
                })}
                title={`View the ${value} call${value !== 1 ? "s" : ""} behind "${label}"`}>
                <div className="mis-card-icon" style={{ background: color + "20", color }}>
                  <Icon size={20}/>
                </div>
                <div>
                  <p className="mis-card-val">{value}</p>
                  <p className="mis-card-label">{label}</p>
                </div>
                <MousePointerClick size={13} className="mis-card-click-hint"/>
              </div>
            ))}
          </div>

          {/* Cross-Module Overview — Leads/Properties/Deals/Payments/Documents/Tasks/Visits/Meetings,
              pulled from every module's own collection (not just calls that happen to reference them).
              Has its own Daily/Weekly/Monthly/Custom (+ agent) filter, independent of the page-level bar above. */}
          <div className="mis-chart-header" style={{ marginBottom: 10 }}>
            <h3>All Modules — Period Overview</h3>
            {moduleOverviewLoading && <RefreshCw size={13} className="mis-spin-icon"/>}
          </div>

          <div className="mis-filters-bar" style={{ marginBottom: 14 }}>
            <div className="mis-tabs">
              {PERIODS.map(p => (
                <button key={p.value}
                  className={`mis-tab ${modPeriod === p.value ? "active" : ""}`}
                  onClick={() => handleModPeriodChange(p.value)}>
                  {p.label}
                </button>
              ))}
            </div>

            {modPeriod === "weekly" && (
              <div className="mis-week-nav">
                <button className="mis-week-nav-btn" onClick={() => setModWeekAnchor(d => addDays(d, -7))} title="Previous week">
                  <ChevronLeft size={14}/>
                </button>
                <span className="mis-week-nav-label">
                  {modWeeklyRange.start.toLocaleDateString("en-IN", { day: "2-digit", month: "short" })}
                  {" (Wed) → "}
                  {modWeeklyRange.end.toLocaleDateString("en-IN", { day: "2-digit", month: "short" })}
                  {" (Mon)"}
                </span>
                <button className="mis-week-nav-btn" onClick={() => setModWeekAnchor(d => addDays(d, 7))}
                  disabled={!modCanGoNextWeek} title="Next week">
                  <ChevronRight size={14}/>
                </button>
              </div>
            )}

            {modPeriod === "custom" && (
              <div className="mis-custom-range">
                <input type="date" value={modFrom} onChange={e => setModFrom(e.target.value)}/>
                <span>→</span>
                <input type="date" value={modTo}   onChange={e => setModTo(e.target.value)}/>
                {modCustomIncomplete && <span className="mis-custom-range-hint">Pick both dates</span>}
              </div>
            )}

            {adminFlag && (
              <div className="mis-filter-group">
                <Users size={13}/>
                <select value={modAgent} onChange={e => setModAgent(e.target.value)}>
                  <option value="">All Agents</option>
                  {users.map(u => (
                    <option key={u._id} value={u._id}>
                      {u.name || u.Name || u.fullName || u.username || u.email || u._id}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {modCustomIncomplete ? (
            <div className="mis-empty" style={{ marginBottom: 22 }}>
              <Calendar size={32} strokeWidth={1}/>
              <p>Select both a "From" and "To" date to load this overview.</p>
            </div>
          ) : (
            <div className="mis-cards" style={{ marginBottom: 22 }}>
              {moduleTotals.map(({ key, label, icon: Icon, color, value, isCurrency, moduleKey }) => (
                <div key={key} className="mis-card mis-clickable"
                  onClick={() => openModuleDetails(moduleKey, label)}
                  title={`View the ${value} record${value !== 1 ? "s" : ""} behind "${label}"`}>
                  <div className="mis-card-icon" style={{ background: color + "20", color }}>
                    <Icon size={20}/>
                  </div>
                  <div>
                    <p className="mis-card-val">{isCurrency ? fmt(value) : value}</p>
                    <p className="mis-card-label">{label}</p>
                  </div>
                  <MousePointerClick size={13} className="mis-card-click-hint"/>
                </div>
              ))}
            </div>
          )}

          {/* Pie Chart Section */}
          {rows.length > 0 && <PieChartSection rows={rows} usersMap={usersMap} period={period} openDetails={openDetails}/>}

          {/* Table */}
          <div className="mis-table-wrap">
            {rows.length === 0 ? (
              <div className="mis-empty">
                <BarChart3 size={44} strokeWidth={1}/>
                <p>{rawRows.length > 0 ? `No agents match "${search}"` : "No data for this period"}</p>
              </div>
            ) : (
              <table className="mis-table">
                <thead>
                  <tr>
                    <th style={{ width: 32 }}/>
                    <th>#</th>
                    <th className="mis-th-sort" onClick={() => toggleSort("name")}>
                      Agent <SortIcon col="name"/>
                    </th>
                    <th className="mis-th-sort" onClick={() => toggleSort("numberOfCalls")}>
                      Calls <SortIcon col="numberOfCalls"/>
                    </th>
                    <th className="mis-th-sort" onClick={() => toggleSort("closed")}>
                      Closed <SortIcon col="closed"/>
                    </th>
                    <th>Status Mix</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, idx) => {
                    const { name: displayName, email: displayEmail, letter: avatarLetter } = resolveAgent(r, usersMap);
                    const statusBreakdown = {
                      NotAnswering: r.statusNotAnswering  || 0,
                      New:          r.statusNew           || 0,
                      Interested:   r.statusInterested    || 0,
                      Negotiating:  r.statusNegotiating   || 0,
                      NotInterested:r.statusNotInterested || 0,
                      Followup:     r.statusFollowup      || 0,
                      Closed:       r.closed              || 0,
                    };
                    const dm = dashboardMap[(r.userEmail || displayEmail || "").toLowerCase()];
                    const moduleChips = dm ? [
                      { label: "Leads Created",     value: dm.leadsCreated,      color: "#6366f1" },
                      { label: "Properties Listed", value: dm.propertiesListed,  color: "#f59e0b" },
                      { label: "Deals Won",         value: dm.dealsWon,          color: "#22c55e" },
                      { label: "Deal Value",        value: dm.totalDealValue,    color: "#22c55e", isCurrency: true },
                      { label: "Payments Received", value: dm.paymentsReceived,  color: "#10b981", isCurrency: true },
                      { label: "Documents",         value: dm.documentsUploaded, color: "#8b5cf6" },
                      { label: "Tasks Completed",   value: dm.tasksCompleted,    color: "#0ea5e9" },
                      { label: "Buyer Visits",      value: dm.clientVisitsTotal, color: "#06b6d4" },
                      { label: "Seller Visits",     value: dm.selfVisits,        color: "#06b6d4" },
                      { label: "Meetings",          value: dm.meetingsScheduled, color: "#ec4899" },
                    ].filter(c => c.value > 0) : [];
                    return (
                      <React.Fragment key={r._id || idx}>
                        <tr className="mis-main-row" onClick={() => toggleRow(idx)}>
                          <td className="mis-expand-cell">
                            {expanded[idx] ? <ChevronDown size={14}/> : <ChevronRight size={14}/>}
                          </td>
                          <td className="mis-rank">{idx + 1}</td>
                          <td>
                            <div className="mis-user">
                              <div className="mis-avatar">{avatarLetter}</div>
                              <div>
                                <p className="mis-uname">{displayName}</p>
                                <p className="mis-uemail">{displayEmail}</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="mis-num calls mis-clickable"
                              title={`View all ${r.numberOfCalls} calls for ${displayName}`}
                              onClick={(e) => { e.stopPropagation(); openDetails({
                                title: `${displayName} — All Calls`,
                                subtitle: `${period.charAt(0).toUpperCase() + period.slice(1)} · ${r.numberOfCalls} record${r.numberOfCalls !== 1 ? "s" : ""}`,
                                agentKey: r._id,
                              }); }}>
                              {r.numberOfCalls}
                            </span>
                          </td>
                          <td>
                            <span className={`mis-closed mis-clickable ${r.closed > 0 ? "has" : "zero"}`}
                              title={`View ${r.closed || 0} closed calls for ${displayName}`}
                              onClick={(e) => { e.stopPropagation(); openDetails({
                                title: `${displayName} — Closed Calls`,
                                subtitle: `${period.charAt(0).toUpperCase() + period.slice(1)} · ${r.closed || 0} record${r.closed !== 1 ? "s" : ""}`,
                                agentKey: r._id,
                                callStatus: "Closed",
                              }); }}>
                              {r.closed || 0}
                            </span>
                          </td>
                          <td>
                            <span className="mis-clickable" title={`View call breakdown for ${displayName}`}
                              onClick={(e) => { e.stopPropagation(); openDetails({
                                title: `${displayName} — All Calls`,
                                subtitle: `${period.charAt(0).toUpperCase() + period.slice(1)} · ${r.numberOfCalls} record${r.numberOfCalls !== 1 ? "s" : ""}`,
                                agentKey: r._id,
                              }); }}>
                              <StatusPie breakdown={statusBreakdown}/>
                            </span>
                          </td>
                        </tr>

                        {expanded[idx] && (
                          <tr className="mis-detail-row">
                            <td colSpan={6}>
                              <div className="mis-detail-grid">

                                {Object.values(statusBreakdown).some(v => v > 0) && (
                                  <div className="mis-detail-section mis-sb-section">
                                    <h4><BarChart3 size={13}/> Call Status Breakdown</h4>
                                    <div className="mis-status-chips">
                                      {Object.entries(statusBreakdown).map(([k, v]) =>
                                        v > 0 ? (
                                          <span key={k} className="mis-status-chip mis-clickable"
                                            title={`View the ${v} "${STATUS_PIE_LABELS[k] || k}" calls for ${displayName}`}
                                            style={{
                                              background: (STATUS_PIE[k] || "#6b7280") + "18",
                                              color:       STATUS_PIE[k] || "#6b7280",
                                              border:     `1px solid ${(STATUS_PIE[k] || "#6b7280")}40`,
                                            }}
                                            onClick={(e) => { e.stopPropagation(); openDetails({
                                              title: `${displayName} — ${STATUS_PIE_LABELS[k] || k}`,
                                              subtitle: `${period.charAt(0).toUpperCase() + period.slice(1)} · ${v} record${v !== 1 ? "s" : ""}`,
                                              agentKey: r._id,
                                              callStatus: PIE_KEY_TO_CALL_STATUS[k] || k,
                                            }); }}>
                                            {STATUS_PIE_LABELS[k] || k}: <strong>{v}</strong>
                                          </span>
                                        ) : null
                                      )}
                                    </div>
                                  </div>
                                )}

                                {moduleChips.length > 0 && (
                                  <div className="mis-detail-section mis-sb-section">
                                    <h4><BarChart3 size={13}/> All Modules — This Period</h4>
                                    <div className="mis-status-chips">
                                      {moduleChips.map(c => (
                                        <span key={c.label} className="mis-status-chip"
                                          style={{ background: c.color + "18", color: c.color, border: `1px solid ${c.color}40` }}>
                                          {c.label}: <strong>{c.isCurrency ? fmt(c.value) : c.value}</strong>
                                        </span>
                                      ))}
                                    </div>
                                  </div>
                                )}

                                {r.leads?.length > 0 && (
                                  <div className="mis-detail-section">
                                    <h4><Users size={13}/> Leads ({r.leads.length})</h4>
                                    {r.leads.filter(Boolean).map(l => (
                                      <div key={l._id} className="mis-detail-card lead-card">
                                        <p className="dc-name">{l.name || "—"}</p>
                                        <p className="dc-sub">
                                          {l.phone}{l.status && ` · ${l.status}`}{l.interest_level && ` · ⭐ ${l.interest_level}`}
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {r.properties?.length > 0 && (
                                  <div className="mis-detail-section">
                                    <h4><Building2 size={13}/> Properties ({r.properties.length})</h4>
                                    {r.properties.filter(Boolean).map(p => (
                                      <div key={p._id} className="mis-detail-card prop-card">
                                        <p className="dc-name">{p.name || "—"}</p>
                                        <p className="dc-sub">
                                          {p.location}{p.price && ` · ${fmt(p.price)}`}{p.status && ` · ${p.status}`}
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {r.deals?.length > 0 && (
                                  <div className="mis-detail-section">
                                    <h4><TrendingUp size={13}/> Deals ({r.deals.length})</h4>
                                    {r.deals.filter(Boolean).map(d => {
                                      const sc = STAGE_COLOR[d.stage] || { bg: "#f3f4f6", color: "#374151" };
                                      return (
                                        <div key={d._id} className="mis-detail-card deal-card">
                                          <div className="dc-deal-top">
                                            <p className="dc-name">{d.name || "—"}</p>
                                            <span className="dc-stage" style={{ background: sc.bg, color: sc.color }}>{d.stage}</span>
                                          </div>
                                          <p className="dc-sub">
                                            {d.dealValue && <><IndianRupee size={11}/>{Number(d.dealValue).toLocaleString("en-IN")}</>}
                                            {d.expectedCloseDate && ` · Close: ${new Date(d.expectedCloseDate).toLocaleDateString()}`}
                                            {d.agreementSigned && " · ✓ Signed"}
                                          </p>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}

                                {(!r.leads?.length && !r.properties?.length && !r.deals?.length &&
                                  !moduleChips.length && !Object.values(statusBreakdown).some(v => v > 0)) && (
                                  <p className="mis-detail-empty">No activity for this agent in this period.</p>
                                )}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="mis-total-row">
                    <td colSpan={3}><strong>Total ({rows.length} agents)</strong></td>
                    <td><strong>{sumField(rows, "numberOfCalls")}</strong></td>
                    <td><strong>{sumField(rows, "closed")}</strong></td>
                    <td/>
                  </tr>
                </tfoot>
              </table>
            )}
          </div>
        </>
      )}

      {detailModal && (
        <MISDetailsModal
          title={detailModal.title}
          subtitle={detailModal.subtitle}
          params={detailModal.params}
          onClose={() => setDetailModal(null)}
        />
      )}

      {moduleDetailModal && (
        <ModuleDetailsModal
          title={moduleDetailModal.title}
          subtitle={moduleDetailModal.subtitle}
          params={moduleDetailModal.params}
          onClose={() => setModuleDetailModal(null)}
        />
      )}
    </div>
  );
}